<!-- 
  EventStatistics.vue
  이벤트 현황 페이지
  
  - 특정 이벤트의 현황 정보 표시
  - eventId로 이벤트 정보 조회
-->
<template>
  <div class="container-fluid col-sm-12 col-xs-12">
    <div style="margin-top: 28px"></div>
    <!-- 페이지 헤더 영역 -->
    <div class="card-header pb-0 col-sm-12 d-flex">
      <div class="col-sm-12 col-xs-12">
        <div class="col-sm-12 col-xs-12 justify-content-between titleContainer">
          <div class="title-row">
            <div>
              <h1 class="fw-bold page-title">
                스마일 카드 공유 이벤트 현황
              </h1>
              <span class="pageDesc">스마일 카드 공유 이벤트의 현황 정보를 확인할 수 있습니다.</span>
            </div>
            <div class="header-actions">
              
              <div class="event-filter-left">
                  <div class=event-filter-row>
                      <label class="label" style="margin-right: 20px;">이벤트 캠페인 선택</label>
                      <a-select
                          v-model:value="selectedEventId"
                          class="event-select"
                          @change="handleEventChange"
                          
                      >
                          <a-select-option
                              value="dummyEventId"
                          >
                          2024 여름 이벤트(2024/08/01 ~ 2024/09/30)
                          </a-select-option>
                          <a-select-option
                              value="dummyEventId2"
                          >
                            2024 설문이벤트(2024/09/02 ~ 2024/09/30)
                          </a-select-option>
                          <a-select-option
                              value="dummyEventId3"
                          >
                            2025 여름 후기 이벤트 (2025-06-20 ~ 2025-08-31)
                          </a-select-option>
                          <a-select-option
                            :value="eventId"
                          >
                            스마일 카드 공유 이벤트 (2025-07-03 ~ 2025-08-31)
                          </a-select-option>
                      </a-select>
                  </div>
              </div>
              <!-- <div class="date-filter">
                <span class="date-label">기간 선택</span>
                <a-range-picker
                  v-model:value="dateRange"
                  :placeholder="['시작일', '종료일']"
                  format="YYYY. MM. DD."
                  @change="handleDateChange"
                  :allow-clear="false"
                />
                <div class="date-filter-buttons">
                  <a-button 
                    v-for="option in dateFilterOptions"
                    :key="option.value"
                    size="small" 
                    @click="setDateRange(option.value)" 
                    :type="dateFilter === option.value ? 'primary' : 'default'"
                  >
                    {{ option.label }}
                  </a-button>
                </div>
              </div> -->
              <a-button class="back-button" @click="goBack">
                <i class="fa fa-arrow-left" style="margin-right: 5px"></i> 뒤로가기
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 콘텐츠 영역 -->
    <div class="card-body px-0 pt-3 pb-2">
      <div class="card content-wrap-card">
        <div class="section-header">
          <div class="section-title">
            <i class="fa fa-chart-line" style="margin-right: 8px"></i>이벤트 현황
          </div>
        </div>
        
        <div class="content-section" v-if="!loadingStats">
          <!-- 전체 현황 요약 -->
          <div class="stats-section">
            <div class="stats-title">
              <i class="fa fa-chart-bar"></i>
              <span>전체 현황 요약</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 400px;">
                    <p><strong>전체 현황 요약</strong></p>
                    <p>메시지 발송부터 최종 참여까지의 전체 현황을 한눈에 볼 수 있습니다.</p>
                    <br/>
                    <p><strong>활용 팁:</strong></p>
                    <p>• 전환율: 응모한사람 ÷ 알림톡발송성공건수 × 100</p>
                    <p>• 참여 완성도: 만족도후기모두작성 ÷ 응모한사람 × 100</p>
                    <p>• 메시지 효율성: 알림톡발송성공건수 ÷ 메시지발송시도건수 × 100</p>
                  </div>
                </template>
                <i class="fa fa-question-circle help-icon"></i>
              </a-tooltip>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 800px;">
                    <p><strong>🔧 백엔드 데이터 집계 로직</strong></p>
                    <br/>
                    <p><strong>1. 기본 집계 원칙</strong></p>
                    <ul>
                      <li>모든 데이터는 MongoDB의 eventattendees 컬렉션에서 집계</li>
                      <li>날짜 필터는 messageSendHistory.requestedAt 기준</li>
                      <li>중복 제거는 고유 문서(_id) 기준</li>
                    </ul>
                    <br/>
                    <p><strong>2. 주요 필드 구조</strong></p>
                    <ul>
                      <li><strong>messageSendHistory[]</strong>: 메시지 발송 이력 배열</li>
                      <li><strong>activities[]</strong>: 사용자 활동 이력 배열</li>
                      <li><strong>certificate</strong>: 수술 인증서 정보</li>
                      <li><strong>status</strong>: 참여자 상태 (viewed, clicked 등)</li>
                    </ul>
                    <br/>
                    <p><strong>3. 날짜 필터 적용</strong></p>
                    <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
messageSendHistory: {
  $elemMatch: {
    requestedAt: {
      $gte: startDate,
      $lte: endDate
    }
  }
}</pre>
                  </div>
                </template>
                <i class="fa fa-exclamation-circle backend-icon"></i>
              </a-tooltip>
              
                <!-- 사용자 타입 필터 -->
                <div class="view-switcher">
                  <a-radio-group v-model:value="selectedUserType" @change="handleUserTypeChange" size="small">
                    <a-tooltip placement="top">
                      <template #title>시술받은 환자 (고객)</template>
                      <a-radio-button value="customer">시술받은 환자</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>환자의 친구</template>
                      <a-radio-button value="customer_friend">환자의 친구</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>친구의 친구</template>
                      <a-radio-button value="friend_of_friend">친구의 친구</a-radio-button>
                    </a-tooltip>
                  </a-radio-group>
                </div>
                <!-- 데이터 기준 필터 -->
                <!-- <div class="view-switcher">
                  <a-radio-group v-model:value="selectedView" @change="handleViewChange" size="small">
                    <a-tooltip placement="top">
                      <template #title>중복 제거된 실제 대상자 수</template>
                      <a-radio-button value="uniqueRecipient">고유 수신자</a-radio-button>
                    </a-tooltip>
                    <a-tooltip placement="top">
                      <template #title>재발송 포함 모든 메시지 건수</template>
                      <a-radio-button value="messageCount">메시지 건수</a-radio-button>
                    </a-tooltip>
                  </a-radio-group>
                </div> -->
              </div>
            <div class="stats-subtitle">메시지 발송부터 최종 참여까지의 전체 현황</div>
            
            <div :class="['stats-row', `user-type-${selectedUserType}`]">
              <div 
                v-for="stat in getVisibleStatCards()" 
                :key="stat.key"
                :class="['stat-card', stat.colorClass]"
              >
                <div class="stat-icons">
                  <a-tooltip placement="top" v-if="stat.tooltip">
                    <template #title>
                      <div style="max-width: 350px;" v-html="stat.tooltip"></div>
                    </template>
                    <i class="fa fa-question-circle stat-help-icon"></i>
                  </a-tooltip>
                  <a-tooltip placement="top" v-if="stat.backendTooltip">
                    <template #title>
                      <div style="max-width: 700px;" v-html="stat.backendTooltip"></div>
                    </template>
                    <i class="fa fa-exclamation-circle stat-backend-icon"></i>
                  </a-tooltip>
                </div>
                <div class="stat-number">
                  {{ stat.isPercent ? stat.value + '%' : (stat.value?stat.value.toLocaleString():stat.value) }}
                </div>
                <div class="stat-desc">{{ stat.label }}</div>
                <div class="stat-percent">{{ stat.percent }}{{ typeof stat.percent === 'string' && !stat.percent.includes('%') && !stat.percent.includes('명') && !stat.percent.includes('회') ? '%' : '' }}</div>
              </div>
            </div>
          </div>

          <!-- 대상자 행동 분석 (퍼널) -->
          <div class="stats-section">
            <div class="stats-title">
              <i class="fa fa-filter"></i>
              <span>대상자 행동 분석 (퍼널)</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 800px;">
                    <p><strong>🔧 퍼널 백엔드 데이터 집계 로직</strong></p>
                    <br/>
                    <p><strong>1. 집계 기준</strong></p>
                    <ul>
                      <li>모든 단계는 고유 사용자 수 (중복 제거)</li>
                      <li>activities[].type으로 사용자 행동 추적</li>
                      <li>status로 메시지 클릭/조회 확인</li>
                    </ul>
                    <br/>
                    <p><strong>2. 주요 Activity Types</strong></p>
                    <ul>
                      <li>'카카오 알림톡 하단 버튼 클릭': 이벤트 페이지 진입</li>
                      <li>'이벤트 참여하기 클릭': 참여 시작</li>
                      <li>'스마일 만족도 제출 완료': 만족도 작성</li>
                      <li>'스마일 경험 공유 완료': 후기 작성</li>
                    </ul>
                    <br/>
                    <p><strong>3. 전환율 계산</strong></p>
                    <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
각 단계 전환율 = (현재 단계 수 / 이전 단계 수) × 100
전체 전환율 = (최종 단계 수 / 첫 단계 수) × 100</pre>
                  </div>
                </template>
                <i class="fa fa-exclamation-circle backend-icon"></i>
              </a-tooltip>
            </div>
            <div class="stats-subtitle">이벤트 대상자부터 최종 참여까지의 전환 과정</div>
            
            <div class="funnel-stats">
              <div 
                v-for="(item, index) in getFunnelData()" 
                :key="item.key"
                :class="['funnel-item', item.colorClass]"
              >
                <a-tooltip placement="top" v-if="item.tooltip">
                  <template #title>
                    <div style="max-width: 400px;" v-html="item.tooltip"></div>
                  </template>
                  <i class="fa fa-question-circle funnel-help-icon"></i>
                </a-tooltip>
                <a-tooltip placement="top" v-if="item.hasWarning && item.warningTooltip">
                  <template #title>
                    <div v-html="item.warningTooltip"></div>
                  </template>
                  <i class="fa fa-exclamation-circle funnel-warning-icon"></i>
                </a-tooltip>
                <div class="funnel-bar" :style="{ width: item.width + '%' }"></div>
                <div class="funnel-content">
                  <div class="funnel-number">{{ item.number.toLocaleString() }}</div>
                  <div class="funnel-desc" v-html="item.desc"></div>
                  <div class="funnel-percent">{{ item.percent }}%</div>
                  <div class="funnel-change" v-if="item.change !== 0">
                    -{{ Math.abs(item.change).toLocaleString() }}
                  </div>
                </div>
                <div class="funnel-arrow" v-if="index < getFunnelData().length - 1">→</div>
              </div>
            </div>
            
          </div>

          <!-- 병원별 집계 -->
          <!-- <div class="stats-section" v-if="viewOptions && viewOptions[selectedView]?.data?.hospitalBreakdown?.length > 0">
            <div class="stats-title">
              <i class="fa fa-hospital"></i>
              <span>병원별 집계</span>
              <a-tooltip placement="top">
                <template #title>
                  <div style="max-width: 400px;">
                    <p><strong>병원별 집계</strong></p>
                    <p>병원별 응답자 현황과 참여 성과를 확인할 수 있습니다.</p>
                    <br/>
                    <p><strong>표시 기준:</strong></p>
                    <p>• 응모한사람 기준 상위 20개 병원</p>
                    <p>• 완전작성률 = 만족도,후기모두작성 ÷ 응모한사람</p>
                    <p>• 날짜 필터가 적용된 결과입니다</p>
                  </div>
                </template>
                <i class="fa fa-question-circle help-icon"></i>
              </a-tooltip>
            </div>
            <div class="stats-subtitle">응답자 수 기준 상위 20개 병원의 상세 현황</div>
            
            <div class="hospital-table-wrapper">
              <a-table 
                :columns="hospitalColumns"
                :data-source="hospitalTableData"
                :pagination="false"
                :scroll="{ x: 1050 }"
                size="middle"
                class="hospital-breakdown-table"
              >
                <template #bodyCell="{ column, text, record }">
                  <template v-if="column.dataIndex === 'hospitalName'">
                    <div class="hospital-name">{{ text }}</div>
                  </template>
                  <template v-else-if="column.dataIndex === 'completionRate'">
                    <div class="completion-rate">
                      <span class="rate-value">{{ text }}%</span>
                      <div class="rate-bar">
                        <div class="rate-fill" :style="{ width: text + '%' }"></div>
                      </div>
                    </div>
                  </template>
                </template>
              </a-table>
            </div>
          </div> -->
        </div>
        
        <!-- 로딩 상태 -->
        <div class="content-section" v-if="loadingStats">
          <div class="loading-state">
            <a-spin size="large" />
            <p>통계 데이터를 불러오는 중입니다...</p>
          </div>
        </div>
        <div class="summary-content-section" v-if="!loadingStats">
          <!-- 병원 예약 퍼널 분석 - 2열 배치 -->
          <div class="hospital-booking-funnel-section">
            <div class="funnel-main-header">
              <h3 class="section-title">병원 예약 퍼널 분석</h3>
            </div>
            
            <a-row :gutter="[32, 0]">
              <!-- 전체 이벤트 퍼널 (왼쪽) -->
              <a-col :xs="24" :lg="12">
                <div class="funnel-card">
                  <div class="funnel-header left-funnel">
                    <h4 class="funnel-title">
                      병원 예약 클릭 수 (환자의 친구/친구의 친구)
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 병원 상세 페이지 조회 비율 (상세PV/목록PV) : 0.71</p>
                            <p>■ 병원 게시판, 카페, 블로그 등에 퀴즈 이벤트 페이지가 노출되어 PV 높음</p>
                            <p>■ 김미나(437 views), 박수민(251 views), 김미소(216 views), 장숙희(212 views) 순으로 높음</p>
                            <p>■ 요약(7-8월) 데이터와 동일(데이터 분리 어려움)</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  
                  <div class="funnel-visualization">
                    <div v-for="(step, index) in mainEventFunnel" :key="index" class="funnel-step" :class="`step-${index + 1}`">
                      <div class="step-bar">
                        <div 
                          class="step-progress" 
                          :style="{ width: `${step.percentage}%` }"
                        ></div>
                      </div>
                      <div class="step-content">
                        <div class="step-info">
                          <h5 class="step-title">{{ step.title }}</h5>
                          <div class="step-metrics">
                            <span class="step-count">{{ formatNumber(step.count) }}{{ step.unit }}</span>
                            <span class="step-percentage">{{ step.percentage }}%</span>
                          </div>
                        </div>
                        <div class="step-arrow" v-if="index < mainEventFunnel.length - 1">
                          <i class="fa fa-arrow-down"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-col>
              
              <!-- 환자의 친구/친구의 친구 퍼널 (오른쪽) -->
              <a-col :xs="24" :lg="12">
                <div class="funnel-card">
                  <div class="funnel-header right-funnel">
                    <h4 class="funnel-title">
                      환자의 친구/친구의 친구 병원 예약 도달
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 환자의 친구/ 친구의 친구의 수는 "응모자 수" 기준으로 추출</p>
                            <p>■ 비율 기준은 환자의 친구/친구의 친구 기준</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  
                  <div class="funnel-visualization">
                    <div v-for="(step, index) in friendPatientFunnel" :key="index" class="funnel-step" :class="`step-${index + 1}`">
                      <div class="step-bar">
                        <div 
                          class="step-progress"
                          :style="{ width: `${step.percentage}%` }"
                        ></div>
                      </div>
                      <div class="step-content">
                        <div class="step-info">
                          <h5 class="step-title">{{ step.title }}</h5>
                          <div class="step-metrics">
                            <span class="step-count">{{ formatNumber(step.count) }}{{ step.unit }}</span>
                            <span class="step-percentage" v-if="step.percentage && step.percentage !== ''">{{ step.percentage }}%</span>
                          </div>
                        </div>
                        <div class="step-arrow" v-if="index < friendPatientFunnel.length - 1">
                          <i class="fa fa-arrow-down"></i>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </a-col>
            </a-row>
          </div>

          <!-- 상세 통계 테이블 섹션 (4열 레이아웃) -->
          <div class="detailed-tables-section">
            <div class="section-header">
              <h3 class="section-title">상세 통계 분석</h3>
              <p class="section-desc">이벤트 참여자별 상세 데이터 및 경품 지급 현황을 확인할 수 있습니다</p>
            </div>
            
            <a-row :gutter="[16, 20]">
              <!-- 1. 대상별 이벤트 참여자 수 -->
              <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header participant-header">
                    <h4 class="card-title">
                      <i class="fa fa-users"></i>
                      대상별 이벤트 참여자 수
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 스마일 환자의 대상자 수: 스마일 카드를 카카오톡으로 수신한 환자의 수</p>
                            <p>■ N차 공유로 친구의 친구 응모자수 높음</p>
                            <p>■ 수술한 직후에는 확인서 메시지가 온다는 인지가 있어 클릭 수가 높으나, 수술한 후 시간이 지난 경우에는 알림톡 클릭 수가 떨어짐</p>
                            <p>■ 후기 이벤트는 메시지에 "100% 커피 쿠폰 지급"이 명시되어 있으나, 공유 이벤트에는 선물에 대한 직접적인 언급이 없어 25년 6월 이전 수술자의 메시지 클릭률 떨어짐</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="participantByTarget" 
                      :columns="participantColumns"
                      :pagination="false"
                      size="small"
                      :scroll="{ x: 'max-content' }"
                    />
                  </div>
                </div>
              </a-col>

              <!-- 2. 스마일 환자 수술별 응모자 수 -->
              <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header surgery-header">
                    <h4 class="card-title">
                      <i class="fa fa-eye"></i>
                      스마일 환자 수술별 응모자 수
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="surgeryParticipants" 
                      :columns="surgeryColumns"
                      :pagination="false"
                      size="small"
                    />
                  </div>
                </div>
              </a-col>

              <!-- 3. 스마일 환자 응모자 별 공유 횟수 분포 -->
              <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header share-header">
                    <h4 class="card-title">
                      <i class="fa fa-share-alt"></i>
                      스마일 환자 응모자 별 공유 횟수 분포
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="shareDistribution" 
                      :columns="shareColumns"
                      :pagination="false"
                      size="small"
                    />
                  </div>
                </div>
              </a-col>

              <!-- 4. 스마일 환자 응모자 연령대 분포 -->
              <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header age-header">
                    <h4 class="card-title">
                      <i class="fa fa-chart-bar"></i>
                      스마일 환자 응모자 연령대 분포
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="ageDistribution" 
                      :columns="ageColumns"
                      :pagination="false"
                      size="small"
                    />
                  </div>
                </div>
              </a-col>

              <!-- 5. 참여자 대상 메시지 발송 건 수 -->
              <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header message-header">
                    <h4 class="card-title">
                      <i class="fa fa-envelope"></i>
                      참여자 대상 메시지 발송 건 수
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 1명의 환자에게 N차 발송하여 실제 대상자 수 보다 발송 건수가 더 많음</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="messageStats" 
                      :columns="messageColumns"
                      :pagination="false"
                      size="small"
                      :scroll="{ x: 'max-content' }"
                    />
                  </div>
                </div>
              </a-col>

              <!-- 6. 경품 지급 현황 -->
              <!-- <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header reward-header">
                    <h4 class="card-title">
                      <i class="fa fa-gift"></i>
                      경품 지급 현황
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 자이스 이벤트 예산 초과액은 서티라이프에서 부담</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="rewardStatus" 
                      :columns="rewardStatusColumns"
                      :pagination="false"
                      size="small"
                    />
                  </div>
                </div>
              </a-col> -->

              <!-- 7. 경품 소진 현황 -->
              <!-- <a-col :xs="24" :sm="12" :md="12" :lg="4" style="width:20% !important; flex:0 0 20%; max-width:20%;">
                <div class="table-card">
                  <div class="card-header depletion-header">
                    <h4 class="card-title">
                      <i class="fa fa-chart-line"></i>
                      경품 소진 현황
                      <a-tooltip>
                        <template #title>
                          <div class="funnel-tooltip">
                            <p>■ 경품 수신율 63.5%</p>
                            <p>■ 컴포즈 커피 수신 대상자: 후기 작성자, 3회 이상 공유자, 환자의친구/친구의친구 퀴즈푼 인원</p>
                            <p>■ 수신자 수(전체): 친구에게 공유하지 않고 퀴즈만 푼 사람도 포함</p>
                          </div>
                        </template>
                        <i class="fa fa-info-circle funnel-info-icon"></i>
                      </a-tooltip>
                    </h4>
                  </div>
                  <div class="table-content">
                    <a-table 
                      :dataSource="rewardDepletion" 
                      :columns="depletionColumns"
                      :pagination="false"
                      size="small"
                    />
                  </div>
                </div>
              </a-col> -->
            </a-row>
          </div>

          <!-- 병원별 응모자 수 -->
          <div class="hospital-participants-section">
            <div class="section-header-simple">
              <h3 class="section-title">
                <i class="fa fa-hospital"></i>
                스마일 환자 병원별 응모자 수
              </h3>
            </div>
            
            <div class="hospital-table-content">
              <a-table 
                :dataSource="hospitalParticipants" 
                :columns="hospitalParticipantColumns"
                :pagination="false"
                size="middle"
                :scroll="{ x: 'max-content' }"
                class="hospital-participants-table"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Number 프로토타입에 truncateFixed 메서드 추가
Number.prototype.truncateFixed = function(digits) {
  const multiplier = Math.pow(10, digits);
  return (Math.floor(this * multiplier) / multiplier).toString();
};
import { ref, onMounted, reactive, computed, h, getCurrentInstance } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { message, Tooltip } from 'ant-design-vue';
import eventsApis from './api';
import axios from '@/axios';
import dayjs from 'dayjs';
import { convertToLocalTime } from '@/utils/utils';
import { 
  customerResponseData, 
  customerFriendResponseData, 
  friendOfFriendResponseData 
} from './mocks/eventStatisticsMockData';

export default {
  name: "EventStatistics",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    
    // 상태 변수
    const eventId = ref(null);
    const eventTitle = ref('이벤트');
    const loading = ref(false);
    const loadingStats = ref(false);
    
    // API 인스턴스
    const apiInstance = ref(null);
    
    // 날짜 필터 관련
    const dateRange = ref(null);
    const dateFilter = ref('all');
    
    // 뷰 전환 관련
    const selectedView = ref('uniqueRecipient'); // 데이터 기준: uniqueRecipient, messageCount (기본값: 고유 수신자)
    // const selectedView = ref('uniqueRecipient'); // 데이터 기준: uniqueRecipient, messageCount (기본값: 고유 수신자)
    const selectedUserType = ref('customer'); // 사용자 타입: customer, customer_friend, friend_of_friend (기본값: 시술받은 환자)
    const viewOptions = ref(null);

    // EventStatisticsSummary 데이터 추가
    // 전체 이벤트 퍼널 데이터
    const mainEventFunnel = ref([
      {
        title: '퀴즈 이벤트 페이지 PV',
        count: 169858,
        unit: '건',
        percentage: 100,
        color: '#1890ff'
      },
      {
        title: '안과 병원 목록 PV',
        count: 11146,
        unit: '건', 
        percentage: 6.56,
        color: '#52c41a'
      },
      {
        title: '병원 상세 PV',
        count: 7927,
        unit: '건',
        percentage: 4.67,
        color: '#faad14'
      },
      {
        title: '예약하기 클릭 수',
        count: 145,
        unit: '건',
        percentage: 0.09,
        color: '#13c2c2'
      },
      {
        title: '병원 예약',
        count: 43,
        unit: '건',
        percentage: 0.03,
        color: '#722ed1'
      },
      {
        title: '채팅/전화상담',
        count: 3,
        unit: '건',
        percentage: 0.002,
        color: '#eb2f96'
      }
    ]);

    // 환자의 친구/친구의 친구 퍼널 데이터 (사용자 제공 데이터)
    const friendPatientFunnel = ref([
      {
        title: '퀴즈 이벤트 페이지 PV',
        count: 169858,
        unit: '건',
        percentage: '',
        color: '#1890ff'
      },
      {
        title: '퀴즈 이벤트 응모자(환친/친친)',
        count: 28813,
        unit: '명', 
        percentage: 100,
        color: '#52c41a'
      },
      {
        title: '안과 병원 목록 PV',
        count: 11146,
        unit: '건',
        percentage: 39,
        color: '#faad14'
      },
      {
        title: '병원 상세 PV',
        count: 7927,
        unit: '건',
        percentage: 28,
        color: '#13c2c2'
      },
      {
        title: '예약하기 클릭 수',
        count: 145,
        unit: '건',
        percentage: 1,
        color: '#722ed1'
      },
      {
        title: '병원 예약',
        count: 43,
        unit: '건',
        percentage: 0.15,
        color: '#eb2f96'
      },
      {
        title: '채팅/전화상담',
        count: 3,
        unit: '건',
        percentage: 0.01,
        color: '#f759ab'
      }
    ]);

    // 상세 테이블 데이터 정의
    // 1. 대상별 이벤트 참여자 수 (행과 열 바뀜)
    const participantByTarget = ref([
      { key: '1', metric: '대상자 수', smilePatient: 197100, patientFriend: 10391, friendOfFriend: 952 },
      { key: '2', metric: '총 응모자 수', smilePatient: 2530, patientFriend: 3534, friendOfFriend: 25279 },
      { key: '3', metric: '총 공유 수', smilePatient: 10391, patientFriend: 952, friendOfFriend: 5312 }
    ]);

    const participantColumns = ref([
      { title: '구분', dataIndex: 'metric', key: 'metric', width: 120, align: 'center' },
      { title: '스마일 환자', dataIndex: 'smilePatient', key: 'smilePatient', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '환자의 친구', dataIndex: 'patientFriend', key: 'patientFriend', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '친구의 친구', dataIndex: 'friendOfFriend', key: 'friendOfFriend', align: 'right',
        customRender: ({ text }) => formatNumber(text) }
    ]);

    // 2. 스마일 환자 수술별 응모자 수
    const surgeryParticipants = ref([
      { key: '1', surgeryType: '스마일', count: 1610, ratio: 63.64 },
      { key: '2', surgeryType: '스마일 프로', count: 920, ratio: 36.36 },
      { key: '3', surgeryType: '합 계', count: 2530, ratio: 100.0 }
    ]);

    const surgeryColumns = ref([
      { title: '수술별', dataIndex: 'surgeryType', key: 'surgeryType', width: 80, align: 'center' },
      { title: '응모자 수', dataIndex: 'count', key: 'count', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '비율', dataIndex: 'ratio', key: 'ratio', align: 'right',
        customRender: ({ text }) => `${text}%` }
    ]);

    // 3. 스마일 환자 응모자 별 공유 횟수 분포
    const shareDistribution = ref([
      { key: '1', shareRange: '50회 초과', participantCount: 5, ratio: 0.20, memo: '' },
      { key: '2', shareRange: '21회 - 50회', participantCount: 82, ratio: 3.24, memo: '아이패드 최다 공유자 10인 제공' },
      { key: '3', shareRange: '4회 - 20회', participantCount: 470, ratio: 18.58, memo: '에어팟 20회 이상 공유 시 추첨' },
      { key: '4', shareRange: '3회', participantCount: 767, ratio: 30.32, memo: '컴포즈 커피 100% 제공' },
      { key: '5', shareRange: '3회 미만', participantCount: 1206, ratio: 47.67, memo: '' }
    ]);

    const shareColumns = ref([
      { title: '공유 횟수', dataIndex: 'shareRange', key: 'shareRange', width: 90, align: 'center' },
      { title: '환자 수', dataIndex: 'participantCount', key: 'participantCount', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '비율', dataIndex: 'ratio', key: 'ratio', align: 'right',
        customRender: ({ text }) => `${text}%` },
      { title: '비고', dataIndex: 'memo', key: 'memo', align: 'left',
        customRender: ({ text }) => `${text}` }
    ]);

    // 4. 스마일 환자 응모자 연령대 분포
    const ageDistribution = ref([
      { key: '1', ageRange: '24세 이하', count: 716, ratio: 28.30 },
      { key: '2', ageRange: '25-29세', count: 524, ratio: 20.71 },
      { key: '3', ageRange: '30-34세', count: 382, ratio: 15.10 },
      { key: '4', ageRange: '35-39세', count: 191, ratio: 7.55 },
      { key: '5', ageRange: '40세 이상', count: 86, ratio: 3.40 },
      { key: '6', ageRange: '입수 없음', count: 631, ratio: 24.94 }
    ]);

    const ageColumns = ref([
      { title: '연령대', dataIndex: 'ageRange', key: 'ageRange', width: 80, align: 'center' },
      { title: '응모자 수', dataIndex: 'count', key: 'count', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '비율', dataIndex: 'ratio', key: 'ratio', align: 'right',
        customRender: ({ text }) => `${text}%` }
    ]);

    // 5. 참여자 대상 메시지 발송 건 수
    const messageStats = ref([
      { key: '1', messageType: '후기 작성&경품 지급', smilePatient: 23860, friendPatient: 0 },
      { key: '2', messageType: '공유 이벤트 참여 독려', smilePatient: 239462, friendPatient: 0 },
      { key: '3', messageType: '병원 예약 유도', smilePatient: 0, friendPatient: 214011 },
      { key: '4', messageType: '메시지 발송 비용', smilePatient: 1053286, friendPatient: 4280220 }
    ]);

    const messageColumns = ref([
      { title: '발송 내용', dataIndex: 'messageType', key: 'messageType', width: 120, align: 'center' },
      { title: '스마일 환자', dataIndex: 'smilePatient', key: 'smilePatient', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '환자의친구/친구의친구', dataIndex: 'friendPatient', key: 'friendPatient', align: 'right',
        customRender: ({ text }) => formatNumber(text) }
    ]);

    // 6. 경품 지급 현황
    const rewardStatus = ref([
      { key: '1', rewardName: '아이패드', budget: 529000, personnel: 10, amount: 5290000 },
      { key: '2', rewardName: '아이폰', budget: 199000, personnel: 20, amount: 3980000 },
      { key: '3', rewardName: '컴포즈 커피(자이스)', budget: 1800, personnel: 500, amount: 900000 },
      { key: '4', rewardName: '컴포즈 커피(서티)', budget: 1800, personnel: null, amount: null }
    ]);

    const rewardStatusColumns = ref([
      { title: '경품 예산', dataIndex: 'rewardName', key: 'rewardName', width: 100, align: 'center' },
      { title: '단가', dataIndex: 'budget', key: 'budget', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '인원 수', dataIndex: 'personnel', key: 'personnel', align: 'right',
        customRender: ({ text }) => text ? formatNumber(text) : '-' },
      { title: '금액', dataIndex: 'amount', key: 'amount', align: 'right',
        customRender: ({ text }) => text ? formatNumber(text) : '-' }
    ]);

    // 7. 경품 소진 현황
    const rewardDepletion = ref([
      { key: '1', depletionType: '컴포즈 커피 대상자 수', unitPrice: 1800, personnel: 41581, amount: null },
      { key: '2', depletionType: '컴포즈 커피 수산자 수(전체)', unitPrice: 1800, personnel: 26402, amount: 47523600 },
      { key: '3', depletionType: '컴포즈 커피 수산자 수(당첨)', unitPrice: 1800, personnel: 4512, amount: 8121600 }
    ]);

    const depletionColumns = ref([
      { title: '경품 소진 현황', dataIndex: 'depletionType', key: 'depletionType', width: 120, align: 'center' },
      { title: '단가', dataIndex: 'unitPrice', key: 'unitPrice', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '인원 수', dataIndex: 'personnel', key: 'personnel', align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '금액', dataIndex: 'amount', key: 'amount', align: 'right',
        customRender: ({ text }) => text ? formatNumber(text) : '-' }
    ]);

    // 병원별 응모자 수 데이터 (사용자 제공 정확한 병원명 기준)
    const hospitalParticipants = ref([
      { key: '1', hospitalName: '메트로안과', smile: 105, smilePro: 67, total: 172, ratio: 6.80 },
      { key: '2', hospitalName: '온누리안과병원', smile: 100, smilePro: 77, total: 177, ratio: 7.00 },
      { key: '3', hospitalName: '밝은눈안과 강남', smile: 53, smilePro: 43, total: 96, ratio: 3.79 },
      { key: '4', hospitalName: 'SNU안과', smile: 50, smilePro: 80, total: 130, ratio: 5.14 },
      { key: '5', hospitalName: '밝은누리안과병원', smile: 36, smilePro: 56, total: 92, ratio: 3.64 },
      { key: '6', hospitalName: '압구정안과의원', smile: 67, smilePro: 44, total: 111, ratio: 4.39 },
      { key: '7', hospitalName: '아이리움안과', smile: 62, smilePro: 29, total: 91, ratio: 3.60 },
      { key: '8', hospitalName: '밝은세상안과', smile: 36, smilePro: 30, total: 66, ratio: 2.61 },
      { key: '9', hospitalName: '신세계안과', smile: 30, smilePro: 53, total: 83, ratio: 3.28 },
      { key: '10', hospitalName: '온누리스마일안과의원', smile: 27, smilePro: 49, total: 76, ratio: 3.00 },
      { key: '11', hospitalName: '서울밝은세상안과', smile: 19, smilePro: 39, total: 58, ratio: 2.29 },
      { key: '12', hospitalName: 'BGN밝은눈안과병원', smile: 8, smilePro: 12, total: 20, ratio: 0.79 },
      { key: '13', hospitalName: '비앤빛안과', smile: 43, smilePro: 55, total: 98, ratio: 3.87 },
      { key: '14', hospitalName: '삼성스마일안과의원', smile: 33, smilePro: 18, total: 51, ratio: 2.02 },
      { key: '15', hospitalName: '삼성미라클안과의원 강남', smile: 34, smilePro: 4, total: 38, ratio: 1.50 },
      { key: '16', hospitalName: '수연세안과의원', smile: 15, smilePro: 27, total: 42, ratio: 1.66 },
      { key: '17', hospitalName: '클리어서울안과', smile: 16, smilePro: 14, total: 30, ratio: 1.19 },
      { key: '18', hospitalName: '파티마안과', smile: 169, smilePro: 0, total: 169, ratio: 6.68 },
      { key: '19', hospitalName: '인천푸른세상안과의원', smile: 26, smilePro: 20, total: 46, ratio: 1.82 },
      { key: '20', hospitalName: '아이플러스안과의원', smile: 26, smilePro: 0, total: 26, ratio: 1.03 },
      { key: '21', hospitalName: '밝은안과21병원', smile: 48, smilePro: 0, total: 48, ratio: 1.90 },
      { key: '22', hospitalName: '강남밝은미소안과 ', smile: 26, smilePro: 13, total: 39, ratio: 1.54 },
      { key: '23', hospitalName: '강남조은눈안과', smile: 25, smilePro: 0, total: 25, ratio: 0.99 },
      { key: '24', hospitalName: 'BGN밝은눈안과', smile: 43, smilePro: 0, total: 43, ratio: 1.70 },
      { key: '25', hospitalName: '새빛안과병원', smile: 13, smilePro: 13, total: 26, ratio: 1.03 },
      { key: '26', hospitalName: '수정안과', smile: 18, smilePro: 23, total: 41, ratio: 1.62 },
      { key: '27', hospitalName: '아이시티안과', smile: 24, smilePro: 0, total: 24, ratio: 0.95 },
      { key: '28', hospitalName: '광주안과의원', smile: 13, smilePro: 0, total: 13, ratio: 0.51 },
      { key: '29', hospitalName: 'GS안과', smile: 48, smilePro: 1, total: 49, ratio: 1.94 },
      { key: '30', hospitalName: '카이안과', smile: 19, smilePro: 28, total: 47, ratio: 1.86 },
      { key: '31', hospitalName: '한길안과병원', smile: 56, smilePro: 45, total: 101, ratio: 3.99 },
      { key: '32', hospitalName: '누네빛안과', smile: 22, smilePro: 0, total: 22, ratio: 0.87 },
      { key: '33', hospitalName: '김기수수안과의원', smile: 10, smilePro: 11, total: 21, ratio: 0.83 },
      { key: '34', hospitalName: '삼성미라클안과 천안점', smile: 12, smilePro: 0, total: 12, ratio: 0.47 },
      { key: '35', hospitalName: '서울온안과 천안점 천안점', smile: 25, smilePro: 0, total: 25, ratio: 0.99 },
      { key: '36', hospitalName: '강남서울밝은안과', smile: 12, smilePro: 0, total: 12, ratio: 0.47 },
      { key: '37', hospitalName: '분당연세플러스안과', smile: 20, smilePro: 0, total: 20, ratio: 0.79 },
      { key: '38', hospitalName: '이지봄안과', smile: 21, smilePro: 0, total: 21, ratio: 0.83 },
      { key: '39', hospitalName: '울산신세계안과', smile: 0, smilePro: 61, total: 61, ratio: 2.41 },
      { key: '40', hospitalName: '더밝은안과의원', smile: 12, smilePro: 3, total: 15, ratio: 0.59 },
      { key: '41', hospitalName: '센트럴윤길중안과의원', smile: 13, smilePro: 0, total: 13, ratio: 0.51 },
      { key: '42', hospitalName: '김안과', smile: 17, smilePro: 0, total: 17, ratio: 0.67 },
      { key: '43', hospitalName: '서울신세계안과', smile: 21, smilePro: 0, total: 21, ratio: 0.83 },
      { key: '44', hospitalName: '난초꽃피다안과의원', smile: 11, smilePro: 0, total: 11, ratio: 0.43 },
      { key: '45', hospitalName: '부산성모안과병원', smile: 13, smilePro: 0, total: 13, ratio: 0.51 },
      { key: '46', hospitalName: '압구정에스앤비안과', smile: 13, smilePro: 0, total: 13, ratio: 0.51 },
      { key: '47', hospitalName: '천안나안과', smile: 9, smilePro: 0, total: 9, ratio: 0.36 },
      { key: '48', hospitalName: '하나서울안과', smile: 4, smilePro: 0, total: 4, ratio: 0.16 },
      { key: '49', hospitalName: '센텀소중한눈안과', smile: 10, smilePro: 0, total: 10, ratio: 0.40 },
      { key: '50', hospitalName: '에스안과', smile: 2, smilePro: 0, total: 2, ratio: 0.08 },
      { key: '51', hospitalName: '맑은눈안과', smile: 7, smilePro: 0, total: 7, ratio: 0.28 },
      { key: '52', hospitalName: '미아서울신세계안과', smile: 1, smilePro: 1, total: 2, ratio: 0.08 },
      { key: '53', hospitalName: '광주스마일안과의원', smile: 4, smilePro: 0, total: 4, ratio: 0.16 },
      { key: '54', hospitalName: '보라안과병원', smile: 2, smilePro: 0, total: 2, ratio: 0.08 },
      { key: '55', hospitalName: '퍼스트안과', smile: 14, smilePro: 4, total: 18, ratio: 0.71 },
      { key: '56', hospitalName: '아이백안과', smile: 9, smilePro: 0, total: 9, ratio: 0.36 },
      { key: '57', hospitalName: '예일안과', smile: 5, smilePro: 0, total: 5, ratio: 0.20 },
      { key: '58', hospitalName: '빛사랑안과', smile: 0, smilePro: 0, total: 0, ratio: 0.00 },
      { key: '59', hospitalName: '수원이안과', smile: 11, smilePro: 0, total: 11, ratio: 0.43 },
      { key: '60', hospitalName: '인천퍼스트안과', smile: 5, smilePro: 0, total: 5, ratio: 0.20 },
      { key: '61', hospitalName: '아이러브안과', smile: 0, smilePro: 0, total: 0, ratio: 0.00 },
      { key: '62', hospitalName: 'CK성모안과', smile: 2, smilePro: 0, total: 2, ratio: 0.08 },
      { key: '63', hospitalName: '루원스마일안과', smile: 2, smilePro: 0, total: 2, ratio: 0.08 },
      { key: '64', hospitalName: '강남이룸안과', smile: 5, smilePro: 0, total: 5, ratio: 0.20 },
      { key: '65', hospitalName: '눈에미소안과', smile: 1, smilePro: 0, total: 1, ratio: 0.04 },
      { key: '66', hospitalName: '압구정밝은안과', smile: 3, smilePro: 0, total: 3, ratio: 0.12 },
      { key: '67', hospitalName: '현탑안과의원', smile: 4, smilePro: 0, total: 4, ratio: 0.16 },
      { key: '68', hospitalName: '서울다봄안과의원', smile: 0, smilePro: 0, total: 0, ratio: 0.00 },
      { key: '69', hospitalName: '서면좋은사람안과', smile: 0, smilePro: 0, total: 0, ratio: 0.00 },
      { key: '70', hospitalName: '푸른안과의원', smile: 0, smilePro: 0, total: 0, ratio: 0.00 },
      { key: '71', hospitalName: '판교연세독수리안과', smile: 0, smilePro: 0, total: 0, ratio: 0.00 }
    ]);

    const hospitalParticipantColumns = ref([
      { title: '병원명', dataIndex: 'hospitalName', key: 'hospitalName', width: 200, align: 'center', fixed: 'left' },
      { title: '스마일', dataIndex: 'smile', key: 'smile', width: 80, align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '스마일 프로', dataIndex: 'smilePro', key: 'smilePro', width: 100, align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '합계', dataIndex: 'total', key: 'total', width: 80, align: 'right',
        customRender: ({ text }) => formatNumber(text) },
      { title: '응모자 비율', dataIndex: 'ratio', key: 'ratio', width: 100, align: 'right',
        customRender: ({ text }) => `${text}%` }
    ]);
    
    // 통계 데이터
    const dashboardStats = reactive({
      // 메시지 발송 관련
      메시지발송시도건수: 0,
      알림톡발송성공건수: 0,
      메시지발송실패건수: 0,
      
      // 응답자 통계 (새로운 구조)
      응모한사람: 0,
      만족도만작성: 0,
      후기만작성: 0,
      만족도후기모두작성: 0,
      
      // 수술 타입별 통계
      인증서없는응답자: 0,
      
      // 후기 통계
      후기작성완료건수: 0,
      
      // 카카오톡 공유 관련
      카카오톡공유한사람: 0,
      후기남긴사람: 0,
      공유후기남긴사람: 0,
      카카오톡공유하기횟수: 0,
      
      // 페이지 진입 관련
      이벤트페이지진입: 0,
      병원페이지진입: 0,
      
      // 추가 통계 (화면에 표시할 추가 항목들)
      페이지방문자수: 0,
      참여자분포: {
        만족도만: 0,
        후기만: 0,
        모두작성: 0
      },
      
      // 퍼널 상세 (추가)
      퍼널상세: {
        '1_messageRequested': 0,
        '2_messageSent': 0,
        '3_eventPageVisited': 0,
        '4_participationStarted': 0,
        '5_satisfactionPageEntered': 0,
        '6_reviewPageEntered': 0,
        '7_satisfactionSubmitted': 0,
        '8_reviewTextSubmitted': 0,
        '9_bothCompleted': 0
      }
    });
    
    // 이벤트 정보 조회
    const loadEventDetails = async () => {
      if (!eventId.value || !apiInstance.value) return;
      
      loading.value = true;
      
      try {
        await new Promise((resolve, reject) => {
          apiInstance.value.getEventById(
            eventId.value,
            (response) => {
              console.log('이벤트 상세 정보 조회 성공:', response);
              console.log('Response data:', response.data);
              
              // API 응답 구조에 맞게 데이터 추출
              const eventData = response.data?.data || response.data;
              console.log('Event data:', eventData);
              
              if (eventData && eventData.eventTitle) {
                eventTitle.value = eventData.eventTitle;
                console.log('Event title set to:', eventTitle.value);
              } else {
                console.warn('eventTitle not found in response');
                eventTitle.value = '이벤트';
              }
              resolve();
            },
            (error) => {
              console.error('이벤트 상세 정보 조회 실패:', error);
              reject(error);
            }
          );
        });
      } catch (error) {
        if (error.status === 404) {
          message.error('해당 이벤트를 찾을 수 없습니다.');
        } else {
          message.error('이벤트 정보를 불러오는 중 오류가 발생했습니다.');
        }
      } finally {
        loading.value = false;
      }
    };
    
    // 목업 데이터 사용 여부 확인
    const shouldUseMockData = computed(() => {
      return eventId.value === '6864f97c93111a68978dc3f5';
    });
    
    // 사용자 타입별 목업 데이터 반환
    const getMockDataByUserType = (userType) => {
      const mockDataMap = {
        'customer': customerResponseData,
        'customer_friend': customerFriendResponseData,
        'friend_of_friend': friendOfFriendResponseData
      };
      
      return mockDataMap[userType] || customerResponseData;
    };
    
    // 목업 데이터 응답 생성
    const createMockResponse = () => {
      const mockData = getMockDataByUserType(selectedUserType.value);
      return { data: mockData };
    };
    
    // API 파라미터 생성
    const createApiParams = () => {
      const params = {
        userType: selectedUserType.value,
        dataView: selectedView.value
      };
      
      // 날짜 필터가 설정된 경우 파라미터 추가
      if (dateRange.value && dateRange.value.length === 2) {
        params.startDate = dayjs(dateRange.value[0]).format('YYYY-MM-DD');
        params.endDate = dayjs(dateRange.value[1]).format('YYYY-MM-DD');
      }
      
      return params;
    };
    
    // 대시보드 통계 조회
    const loadDashboardStatistics = async () => {
      if (!eventId.value) return;
      
      loadingStats.value = true;
      
      try {
        let response = null;
        
        if (shouldUseMockData.value) {
          response = createMockResponse();
          console.log('목업 데이터:', response);
        } else {
          const url = `/events-v2/statistics/${eventId.value}/dashboard`;
          const params = createApiParams();
          
          response = await axios.get(url, { params });
        }
        
        if (response.data && response.data.success && response.data.data) {
          const stats = response.data.data;
          console.log('API 응답 데이터:', stats);
          console.log('이벤트페이지진입 값:', stats.이벤트페이지진입);
          console.log('병원페이지진입 값:', stats.병원페이지진입);
          
          // viewOptions가 있는 경우 처리
          if (stats.viewOptions) {
            viewOptions.value = stats.viewOptions;
            // defaultView 설정
            if (stats.defaultView) {
              selectedView.value = stats.defaultView;
            }
            // 선택된 뷰의 데이터를 dashboardStats에 적용
            applyViewData(selectedView.value, stats);
          } else {
            // viewOptions가 없는 경우 기존 방식으로 처리 (하위 호환성)
            Object.keys(dashboardStats).forEach(key => {
              if (key === '퍼널상세' && stats.퍼널상세) {
                // 퍼널상세는 객체이므로 별도 처리
                Object.assign(dashboardStats.퍼널상세, stats.퍼널상세);
              } else if (stats[key] !== undefined) {
                dashboardStats[key] = stats[key];
              }
            });
          }
          
        }
      } catch (error) {
        console.error('대시보드 통계 조회 실패:', error);
        message.error('통계 데이터를 불러오는 중 오류가 발생했습니다.');
      } finally {
        loadingStats.value = false;
      }
    };
    
    // 선택된 뷰의 데이터를 dashboardStats에 적용
    const applyViewData = (view, stats) => {
      if (!viewOptions.value || !viewOptions.value[view]) {
        return;
      }
      
      const viewData = viewOptions.value[view].data;
      console.log('applyViewData 호출됨:', { view, stats, viewData });
      
      // 뷰 데이터를 dashboardStats에 적용
      Object.keys(viewData).forEach(key => {
        if (key === '퍼널상세' && viewData.퍼널상세) {
          // 퍼널상세는 객체이므로 별도 처리
          dashboardStats.퍼널상세 = { ...viewData.퍼널상세 };
        } else if (viewData[key] !== undefined) {
          dashboardStats[key] = viewData[key];
        }
      });
      
      // 루트 레벨의 데이터도 처리 (이벤트페이지진입, 병원페이지진입 등)
      Object.keys(stats).forEach(key => {
        if (key !== 'viewOptions' && key !== 'defaultView' && key !== '퍼널상세' && stats[key] !== undefined) {
          dashboardStats[key] = stats[key];
          console.log(`루트 레벨 데이터 매핑: ${key} = ${stats[key]}`);
        }
      });
    };
    
    // 사용자 타입 변경 핸들러
    const handleUserTypeChange = (e) => {
      const value = e.target.value;
      selectedUserType.value = value;
      // localStorage에 선택 저장
      localStorage.setItem('eventStatsUserType', value);
      // 사용자 타입이 변경되면 API를 다시 호출
      loadDashboardStatistics();
    };

    // 데이터 뷰 변경 핸들러
    const handleViewChange = (e) => {
      const value = e.target.value;
      selectedView.value = value;
      // localStorage에 선택 저장
      localStorage.setItem('eventStatsView', value);
      // 데이터 뷰가 변경되면 API를 다시 호출
      loadDashboardStatistics();
    };
    
    // 날짜 범위 설정
    const setDateRange = (type) => {
      dateFilter.value = type;
      const today = dayjs();
      
      switch (type) {
        case 'all':
          dateRange.value = null;
          break;
        case 'today':
          dateRange.value = [today, today];
          break;
        case 'week':
          dateRange.value = [today.subtract(7, 'day'), today];
          break;
        case 'month':
          dateRange.value = [today.subtract(1, 'month'), today];
          break;
      }
      
      // 통계 다시 로드
      loadDashboardStatistics();
    };
    
    // 날짜 변경 핸들러
    const handleDateChange = () => {
      dateFilter.value = 'custom';
      loadDashboardStatistics();
    };
    
    // 백분율 계산 헬퍼 함수
    const calcPercent = (value, total) => {
      if (!total || total === 0) return '0.0';
      return ((value / total) * 100).toFixed(1);
    };

    // EventStatisticsSummary 유틸리티 함수들 추가
    const formatNumber = (num) => {
      return num?.toLocaleString() || '0';
    };
    
    const calculateConversion = (current, previous) => {
      if (!previous || previous === 0) return '0.0';
      return ((current / previous) * 100).toFixed(1);
    };
    
    // 카드 표시 여부 확인
    const shouldShowCard = (stat) => {
      if (stat.showFor) {
        return stat.showFor.includes(selectedUserType.value);
      }
      return true;
    };
    
    // 표시할 카드들만 필터링
    const getVisibleStatCards = () => {
      return getStatCards().filter(stat => shouldShowCard(stat));
    };
    
    // 통계 카드 데이터 계산
    const getStatCards = () => {
      const total = selectedUserType.value === 'customer' ? dashboardStats.메시지발송시도건수 : dashboardStats.레퍼러로부터공유받은횟수;
      const responseTotal = dashboardStats.응모한사람;
      const satisfactionOrReview = dashboardStats.만족도만작성 + dashboardStats.후기만작성 + dashboardStats.만족도후기모두작성;
      
      return [
        {
          key: 'total',
          value: total,
          label: '메시지 총 발송건수',
          percent: '100',
          colorClass: 'purple',
          showFor: ['customer'],
          tooltip: selectedView.value === 'messageCount' 
            ? `<p><strong>📨 메시지 총 발송건수 (비용 관점)</strong></p>
               <p>카카오 알림톡 API로 전송 요청한 모든 건수입니다.</p>
               <br/>
               <p><strong>💰 비용 계산에 활용</strong></p>
               <ul>
                 <li>건당 15~20원의 발송 비용 × 총 건수</li>
                 <li>재발송, 실패 후 재시도 모두 비용 발생</li>
                 <li>예: 136,477건 × 15원 = 약 205만원</li>
               </ul>
               <br/>
               <p><strong>📊 이 수치가 높은 경우</strong></p>
               <ul>
                 <li>✅ 정상: 대규모 이벤트, 재발송 정책 적용</li>
                 <li>⚠️ 확인필요: 중복 발송이 과도하게 많음</li>
                 <li>💡 개선방안: 발송 대상 정제, 실패율 감소</li>
               </ul>`
            : `<p><strong>👥 실제 도달 대상자 (마케팅 관점)</strong></p>
               <p>실제로 메시지가 도달한 고유한 사용자 수입니다.</p>
               <br/>
               <p><strong>🎯 캠페인 효과 측정</strong></p>
               <ul>
                 <li>실제 몇 명에게 메시지가 전달되었는가</li>
                 <li>응답률 계산의 정확한 분모</li>
                 <li>예: 9,356명 응답 ÷ 131,482명 도달 = 7.1%</li>
               </ul>
               <br/>
               <p><strong>📈 활용 방법</strong></p>
               <ul>
                 <li>ROI 계산: 응답자당 획득 비용</li>
                 <li>타겟팅 효과: 세그먼트별 응답률 비교</li>
                 <li>최적화: 발송 시간대, 메시지 내용 개선</li>
               </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>집계 필드:</strong> eventattendees.messageSendHistory[]</p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
${selectedView.value === 'messageCount' 
  ? 'messageSendHistory 배열의 모든 요소 개수 합계'
  : 'messageSendHistory가 있는 고유 문서 수'}
(날짜 필터 적용 시: requestedAt이 기간 내인 것만)</pre>
                          <p><strong>데이터 출처:</strong> message-statistics API 재활용</p>`
        },
        {
          key: 'success',
          value: dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수,
          label: '알림톡 발송 건수',
          percent: calcPercent(dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수, total),
          colorClass: 'pink',
          showFor: ['customer'],
          tooltip: selectedView.value === 'messageCount'
            ? `<p><strong>✅ 발송 성공 건수 (시스템 관점)</strong></p>
               <p>카카오 API가 정상 처리한 메시지 건수입니다.</p>
               <br/>
               <p><strong>📱 성공의 의미</strong></p>
               <ul>
                 <li>카카오 서버가 메시지를 수락함</li>
                 <li>사용자 카카오톡으로 전송 대기 중</li>
                 <li>❗ 실제 읽음 여부와는 무관</li>
               </ul>
               <br/>
               <p><strong>🔍 성공률 분석</strong></p>
               <ul>
                 <li>현재: ${calcPercent(dashboardStats.알림톡발송성공건수, total)}% 성공</li>
                 <li>업계 평균: 95% 이상</li>
                 <li>90% 미만시 템플릿 검토 필요</li>
               </ul>
               <br/>
               <p><strong>💡 실패 원인 Top 3</strong></p>
               <ul>
                 <li>1️⃣ 수신거부 사용자 (080 거부)</li>
                 <li>2️⃣ 휴대폰 번호 오류</li>
                 <li>3️⃣ 템플릿 변수 불일치</li>
               </ul>`
            : `<p><strong>✅ 성공적으로 도달한 사용자 (사용자 관점)</strong></p>
               <p>메시지를 정상적으로 받을 수 있는 고유 사용자 수입니다.</p>
               <br/>
               <p><strong>📊 도달 가능 대상자</strong></p>
               <ul>
                 <li>총 ${dashboardStats.메시지발송시도건수.toLocaleString()}명 중 ${dashboardStats.알림톡발송성공건수.toLocaleString()}명</li>
                 <li>도달률: ${calcPercent(dashboardStats.알림톡발송성공건수, dashboardStats.메시지발송시도건수)}%</li>
                 <li>미도달: ${(dashboardStats.메시지발송시도건수 - dashboardStats.알림톡발송성공건수).toLocaleString()}명</li>
               </ul>
               <br/>
               <p><strong>🎯 마케팅 인사이트</strong></p>
               <ul>
                 <li>실제 캠페인 도달 범위</li>
                 <li>응답률 계산의 정확한 기준</li>
                 <li>타겟 정확도 평가 지표</li>
               </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>집계 필드:</strong> eventattendees.messageSendHistory[].status</p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
메시지발송시도건수 - 메시지발송실패건수
= totalMessages - failed</pre>
                          <p><strong>실패 조건:</strong> status가 'failed'인 메시지</p>`
        },
        {
          key: 'referralShares',
          value: dashboardStats.레퍼러로부터공유받은횟수 || 0,
          label: '공유받은 횟수',
          percent: `100%`,
          colorClass: 'orange',
          isPercent: false,
          showFor: ['customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📤 공유받은 횟수</strong></p>
                    <p>친구로부터 이벤트 공유를 받은 총 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>총 공유받은 횟수: ${(dashboardStats.레퍼러로부터공유받은횟수 || 0).toLocaleString()}회</li>
                      <li>응모한사람: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>바이럴 마케팅의 핵심 지표</li>
                      <li>친구 추천의 영향력 측정</li>
                      <li>이벤트 확산력 평가</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 레퍼러로부터공유받은횟수</p>
                          <p><strong>집계 방식:</strong> 친구로부터 공유받은 이벤트 횟수</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>`
        },
        {
          key: 'pageVisited',
          value: dashboardStats.이벤트페이지진입 || 0,
          label: '이벤트 페이지 진입 횟수',
          percent: calcPercent(dashboardStats.이벤트페이지진입 || 0, total),
          colorClass: 'cyan',
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>🎯 이벤트 페이지 진입 횟수</strong></p>
                    <p>알림톡의 링크를 클릭하여 이벤트 페이지에 도착한 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이벤트페이지진입 데이터 사용</li>
                      <li>페이지 진입 횟수: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}건</li>
                      <li>메시지 대비 진입률: ${calcPercent(dashboardStats.이벤트페이지진입 || 0, total)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>메시지를 받고 실제로 관심을 보인 사용자</li>
                      <li>이벤트 참여의 첫 번째 단계</li>
                      <li>메시지 내용과 혜택의 매력도를 나타내는 지표</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 이벤트페이지진입</p>
                          <p><strong>집계 방식:</strong> 이벤트 페이지 진입 이벤트 카운트</p>
                          <p><strong>용도:</strong> 메시지 클릭률(CTR) 측정</p>
                          <p><strong>분석:</strong> 메시지 효과성과 사용자 관심도 평가</p>`
        },
        {
          key: 'kakaoShareCount',
          value: dashboardStats.카카오톡공유하기횟수 || 0,
          label: '카카오톡 공유하기 횟수',
          percent: (dashboardStats.카카오톡공유하기횟수 / dashboardStats.응모한사람).truncateFixed(2)+'회 / 인',
          colorClass: 'yellow-light',
          isPercent: false,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📱 카카오톡 공유하기 횟수</strong></p>
                    <p>이벤트 페이지에서 카카오톡으로 공유하기 버튼을 클릭한 총 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>총 공유 횟수: ${(dashboardStats.카카오톡공유하기횟수 || 0).toLocaleString()}회</li>
                      <li>이벤트 페이지 진입 횟수: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}건</li>
                      <li>공유 비율: ${calcPercent(dashboardStats.카카오톡공유하기횟수 || 0, dashboardStats.이벤트페이지진입 || 0)}%</li>
                      <li>응모한 사용자: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명</li>
                      <li>평균 공유 횟수: ${dashboardStats.응모한사람 > 0 ? (dashboardStats.카카오톡공유하기횟수 / dashboardStats.응모한사람).truncateFixed(2) : '0.0'}회/명</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지 진입자 중 공유한 비율</li>
                      <li>이벤트의 바이럴 마케팅 효과를 나타내는 지표</li>
                      <li>사용자들이 이벤트를 친구들에게 공유한 비율</li>
                      <li>높을수록 이벤트의 인지도와 확산력이 좋음을 의미</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 카카오톡공유하기횟수</p>
                          <p><strong>집계 방식:</strong> 카카오톡 공유하기 버튼 클릭 이벤트 카운트</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>
                          <p><strong>분석:</strong> 이벤트 확산력과 사용자 참여도 평가</p>`
        },


        // {
        //   key: 'kakaoShareUsers',
        //   value: dashboardStats.카카오톡공유한사람 || 0,
        //   label: '카카오톡 공유한 사람',
        //   percent: calcPercent(dashboardStats.카카오톡공유한사람 || 0, total),
        //   colorClass: 'pink-light',
        //   tooltip: `<p><strong>📱 카카오톡 공유한 사람</strong></p>
        //             <p>이벤트 페이지에서 카카오톡으로 공유하기 버튼을 클릭한 사용자 수입니다.</p>
        //             <br/>
        //             <p><strong>📊 데이터 계산 방식</strong></p>
        //             <ul>
        //               <li>공유한 사용자: ${(dashboardStats.카카오톡공유한사람 || 0).toLocaleString()}명</li>
        //               <li>전체 응답자 대비 공유율: ${calcPercent(dashboardStats.카카오톡공유한사람 || 0, responseTotal)}%</li>
        //               <li>메시지 대비 공유율: ${calcPercent(dashboardStats.카카오톡공유한사람 || 0, total)}%</li>
        //             </ul>
        //             <br/>
        //             <p><strong>💡 데이터 의미</strong></p>
        //             <ul>
        //               <li>이벤트의 바이럴 마케팅 효과를 나타내는 지표</li>
        //               <li>사용자들이 이벤트를 친구들에게 공유한 비율</li>
        //               <li>높을수록 이벤트의 인지도와 확산력이 좋음을 의미</li>
        //             </ul>`,
        //   backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
        //                   <p><strong>데이터 소스:</strong> 카카오톡공유한사람</p>
        //                   <p><strong>집계 방식:</strong> 카카오톡 공유하기 버튼 클릭한 고유 사용자 수</p>
        //                   <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>
        //                   <p><strong>분석:</strong> 이벤트 확산력과 사용자 참여도 평가</p>`
        // },
        {
          key: 'participants',
          value: dashboardStats.응모한사람 || 0,
          label: '응모한사람',
          percent: calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.레퍼러로부터공유받은횟수 || 0),
          colorClass: 'blue',
          isPercent: false,
          showFor: ['customer','customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>👥 응모한사람</strong></p>
                    <p>이벤트에 실제로 응모한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>응모한사람: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명</li>
                      <li>이벤트 페이지 진입 횟수: ${(dashboardStats.이벤트페이지진입 || 0).toLocaleString()}건</li>
                      <li>응모 비율: ${calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.레퍼러로부터공유받은횟수 || 0)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지 진입자 중 실제 응모한 비율</li>
                      <li>이벤트에 참여한 고유 사용자 수</li>
                      <li>바이럴 마케팅의 핵심 지표</li>
                      <li>친구를 통해 이벤트를 알게 된 사용자</li>
                    </ul>
                    <br/>
                    <p><strong>💡 활용 방법</strong></p>
                    <ul>
                      <li>바이럴 마케팅 효과 측정</li>
                      <li>친구 추천의 영향력 평가</li>
                      <li>이벤트 확산력 분석</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 응모한사람</p>
                          <p><strong>집계 방식:</strong> 이벤트에 응모한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 바이럴 마케팅 효과 측정</p>`
        },
        {
          key: 'reviewUsers',
          value: dashboardStats.후기남긴사람 || 0,
          label: '주관식 후기 남긴 사람',
          percent: calcPercent(dashboardStats.후기남긴사람 || 0, total),
          colorClass: 'green-light',
          showFor: ['customer'],
          tooltip: `<p><strong>✍️ 주관식 후기 남긴 사람</strong></p>
                    <p>이벤트에서 주관식 후기를 작성한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>총 후기 작성자: ${(dashboardStats.후기남긴사람 || 0).toLocaleString()}명</li>
                      <li>메시지 발송 대상자 대비 후기율: ${calcPercent(dashboardStats.후기남긴사람 || 0, total)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>텍스트 후기를 작성한 사용자 비율</li>
                      <li>이벤트 참여의 질적 지표</li>
                      <li>사용자 만족도와 참여 의지 평가</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 후기남긴사람</p>
                          <p><strong>집계 방식:</strong> 주관식 후기를 작성한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 주관식 후기 작성 참여율 측정</p>
                          <p><strong>분석:</strong> 사용자 참여도와 콘텐츠 생성 효과 평가</p>`
        },
        {
          key: 'shareAndReviewUsers',
          value: dashboardStats.공유후기남긴사람 || 0,
          label: '공유+주관식 후기 남긴 사람',
          percent: calcPercent(dashboardStats.공유후기남긴사람 || 0, total),
          colorClass: 'purple-light min-width-185',
          showFor: ['customer'],
          tooltip: `<p><strong>🎯 공유+주관식 후기 남긴 사람</strong></p>
                    <p>카카오톡 공유와 주관식 후기 작성을 모두 완료한 사용자 수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>공유+주관식 후기 모두 완료: ${(dashboardStats.공유후기남긴사람 || 0).toLocaleString()}명</li>
                      <li>메시지 발송 대상자 대비 완료율: ${calcPercent(dashboardStats.공유후기남긴사람 || 0, total)}%</li>
                      <li>주관식 후기 작성자 대비 완료율: ${calcPercent(dashboardStats.공유후기남긴사람 || 0, dashboardStats.후기남긴사람 || 0)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>가장 적극적으로 참여한 핵심 고객</li>
                      <li>이벤트의 최종 목표 달성 지표</li>
                      <li>보상 지급의 주요 대상</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>데이터 소스:</strong> 공유+주관식 후기남긴사람</p>
                          <p><strong>집계 방식:</strong> 카카오톡 공유와 주관식 후기를 모두 완료한 고유 사용자 수</p>
                          <p><strong>용도:</strong> 이벤트 완료율 측정</p>
                          <p><strong>분석:</strong> 최종 참여 목표 달성도 평가</p>`
        },
        // customer_friend, friend_of_friend용 새로운 카드들
        {
          key: 'rate',
          value: calcPercent(responseTotal, dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수),
          label: '전체 참여율',
          percent: `응답: ${responseTotal.toLocaleString()}명`,
          colorClass: 'cyan-light',
          isPercent: true,
          showFor: ['customer'],
          tooltip: `<p><strong>📊 전체 참여율</strong></p>
                    <p>알림톡을 받은 사람 중 실제로 이벤트에 참여한 비율입니다.</p>
                    <ul>
                      <li>계산식: 응모한사람 ÷ 알림톡발송성공건수 × 100</li>
                      <li>이벤트의 전반적인 성과를 나타내는 핵심 지표</li>
                      <li>높을수록 성공적인 캠페인으로 평가됩니다</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
(응모한사람 / 알림톡발송성공건수) × 100</pre>
                          <p><strong>용도:</strong> 이벤트 성과의 핵심 KPI</p>
                          <p><strong>분석:</strong> 알림톡 효과성과 참여 유도력 평가</p>`
        },
        {
          key: 'rateForFriends',
          value: calcPercent(dashboardStats.응모한사람 || 0, dashboardStats.레퍼러로부터공유받은횟수 || 0),
          label: '전체 참여율',
          percent: `응답: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명`,
          colorClass: 'cyan-light',
          isPercent: true,
          showFor: ['customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>📊 전체 참여율</strong></p>
                    <p>공유받은 횟수 대비 응모한 비율입니다.</p>
                    <ul>
                      <li>계산식: 응모한사람 ÷ 공유받은횟수 × 100</li>
                      <li>바이럴 마케팅의 전반적인 성과를 나타내는 핵심 지표</li>
                      <li>높을수록 성공적인 바이럴 캠페인으로 평가됩니다</li>
                    </ul>`,
          backendTooltip: `<p><strong>🔧 백엔드 집계 로직</strong></p>
                          <p><strong>계산 공식:</strong></p>
                          <pre style="background: #2d2d2d; color: #f8f8f2; padding: 12px; border-radius: 4px; font-size: 12px; white-space: pre-wrap; overflow-x: auto;">
(응모한사람 / 레퍼러로부터공유받은횟수) × 100</pre>
                          <p><strong>용도:</strong> 바이럴 마케팅 성과의 핵심 KPI</p>
                          <p><strong>분석:</strong> 친구 추천 효과성과 참여 유도력 평가</p>`
        }
      ];
    };
    
    // 퍼널 데이터 계산
    const getFunnelData = () => {
      // 사용자 타입에 따라 다른 기준 사용
      const isCustomerType = selectedUserType.value === 'customer';
      const total = isCustomerType ? dashboardStats.메시지발송시도건수 : dashboardStats.레퍼러로부터공유받은횟수;
      
      // 전체 현황 요약 데이터를 기준으로 사용
      const messageSent = total;
      const kakaoSuccess = isCustomerType ? (dashboardStats.메시지발송시도건수 - dashboardStats.메시지발송실패건수) : (dashboardStats.레퍼러로부터공유받은횟수 || 0);
      const pageVisited = dashboardStats.이벤트페이지진입 || 0;
      const kakaoShare = dashboardStats.카카오톡공유하기횟수 || 0;
      const hospitalPageEntered = dashboardStats.병원페이지진입 || 0;
      
      // API 데이터에서 직접 가져오기
      const satisfactionOrReview = dashboardStats.만족도만작성 + dashboardStats.후기만작성 + dashboardStats.만족도후기모두작성;
      const completeAll = dashboardStats.만족도후기모두작성;
      
      const funnelData = [
        {
          key: 'target',
          number: isCustomerType ? messageSent : total,
          desc: '이벤트 대상자',
          percent: '100',
          width: 100,
          colorClass: 'green',
          change: 0,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: (selectedView.value === 'messageCount'
              ? `<p><strong>1️⃣ 메시지 발송 요청</strong></p>
                 <p>시스템에 메시지 발송을 요청한 총 건수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>eventattendees.messageSendHistory 배열의 모든 요소 개수</li>
                   <li>중복 발송 포함: 한 사용자에게 여러 번 발송 시 각각 집계</li>
                   <li>재발송 포함: 실패 후 재시도한 건수도 포함</li>
                   <li>상태 무관: requested, sent, failed 모두 포함</li>
                 </ul>
                 <br/>
                 <p><strong>💰 비용 관련</strong></p>
                 <ul>
                   <li>총 ${(messageSent || 0).toLocaleString()}건 × 15원 = ${((messageSent || 0) * 15).toLocaleString()}원</li>
                   <li>실패 건수도 비용 발생</li>
                   <li>카카오 알림톡 API 과금 기준</li>
                 </ul>`
              : `<p><strong>1️⃣ 이벤트 대상자</strong></p>
                 <p>알림톡을 받은 고유한 사용자 수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>eventattendees 컬렉션의 고유 문서 수</li>
                   <li>messageSendHistory가 있는 참석자만 집계</li>
                   <li>중복 제거: 한 사용자가 여러 번 받아도 1명으로 집계</li>
                   <li>customerId 기준으로 중복 제거</li>
                 </ul>
                 <br/>
                 <p><strong>📈 중복 발송 현황</strong></p>
                 <ul>
                   <li>총 발송: ${viewOptions.value?.messageCount?.data?.메시지발송시도건수?.toLocaleString() || '136,477'}건</li>
                   <li>고유 대상: ${(messageSent || 0).toLocaleString()}명</li>
                   <li>중복 발송: ${((viewOptions.value?.messageCount?.data?.메시지발송시도건수 || 136477) - (messageSent || 0)).toLocaleString()}건</li>
                   <li>평균 발송 횟수: ${((viewOptions.value?.messageCount?.data?.메시지발송시도건수 || 136477) / (messageSent || 1)).toFixed(1)}회/명</li>
                 </ul>`)
        },
        {
          key: 'sent',
          number: kakaoSuccess,
          desc: '카카오톡 알림<br>발송 성공',
          percent: calcPercent(kakaoSuccess, messageSent),
          width: parseFloat(calcPercent(kakaoSuccess, messageSent)),
          colorClass: 'blue',
          change: messageSent - kakaoSuccess,
          showFor: ['customer'] ,
          tooltip: (selectedView.value === 'messageCount'
              ? `<p><strong>2️⃣ 카카오톡 발송 성공</strong></p>
                 <p>카카오 API가 성공적으로 처리한 메시지 건수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>이전 단계: ${(messageSent || 0).toLocaleString()}건 (발송 요청)</li>
                   <li>현재 단계: ${(kakaoSuccess || 0).toLocaleString()}건 (발송 성공)</li>
                   <li>실패: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}건</li>
                   <li>성공률: ${calcPercent(kakaoSuccess, messageSent)}%</li>
                 </ul>
                 <br/>
                 <p><strong>❌ 실패 내역</strong></p>
                 <ul>
                   <li>총 실패: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}건</li>
                   <li>messageSendHistory에서 status='failed'인 건수</li>
                   <li>주요 원인: 수신거부, 번호오류, 템플릿 오류 등</li>
                 </ul>`
              : `<p><strong>2️⃣ 메시지 도달 가능 사용자</strong></p>
                 <p>카카오톡을 정상적으로 받을 수 있는 고유 사용자 수입니다.</p>
                 <br/>
                 <p><strong>📊 데이터 계산 방식</strong></p>
                 <ul>
                   <li>이전 단계: ${(messageSent || 0).toLocaleString()}명 (전체 대상)</li>
                   <li>현재 단계: ${(kakaoSuccess || 0).toLocaleString()}명 (도달 가능)</li>
                   <li>도달 불가: ${((messageSent || 0) - (kakaoSuccess || 0)).toLocaleString()}명</li>
                   <li>도달률: ${calcPercent(kakaoSuccess, messageSent)}%</li>
                 </ul>
                 <br/>
                 <p><strong>📝 집계 방식</strong></p>
                 <ul>
                   <li>eventattendees에서 최종 status='sent'인 고유 사용자</li>
                   <li>재발송 시도 후 최종 성공한 경우도 포함</li>
                   <li>중복 제거: 여러 번 성공해도 1명으로 집계</li>
                 </ul>`)
        },
        {
          key: 'pageVisited',
          number: pageVisited,
          desc: '이벤트 페이지<br>진입 횟수',
          percent: calcPercent(pageVisited, messageSent),
          width: parseFloat(calcPercent(pageVisited, messageSent)),
          colorClass: 'yellow',
          change: kakaoSuccess - pageVisited,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>3️⃣ 이벤트 페이지 진입 횟수</strong></p>
                    <p>알림톡의 링크를 클릭하여 이벤트 페이지에 도착한 횟수입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${kakaoSuccess.toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'} (발송 성공)</li>
                      <li>현재 단계: ${pageVisited.toLocaleString()}건 (페이지 도착 횟수)</li>
                      <li>클릭률(CTR): ${calcPercent(pageVisited, kakaoSuccess)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 클릭률(CTR) 의미</strong></p>
                    <ul>
                      <li>알림톡을 받은 사용자 중 실제로 관심을 보인 비율</li>
                      <li>알림톡 내용과 혜택의 매력도를 나타내는 지표</li>
                      <li>일반적으로 15~25%가 양호한 수준</li>
                    </ul>`
        },
        {
          key: 'participants',
          number: dashboardStats.응모한사람 || 0,
          desc: '응모한사람',
          percent: calcPercent(dashboardStats.응모한사람 || 0, messageSent),
          width: parseFloat(calcPercent(dashboardStats.응모한사람 || 0, messageSent)),
          colorClass: 'orange',
          change: pageVisited - (dashboardStats.응모한사람 || 0),
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>4️⃣ 응모한사람</strong></p>
                    <p>이벤트 페이지에 진입한 후 실제로 이벤트에 응모한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${pageVisited.toLocaleString()}건 (이벤트 페이지 진입 횟수)</li>
                      <li>현재 단계: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명 (실제 응모)</li>
                      <li>미응모: ${(pageVisited - (dashboardStats.응모한사람 || 0)).toLocaleString()}명</li>
                      <li>응모율: ${calcPercent(dashboardStats.응모한사람 || 0, pageVisited)}%</li>
                    </ul>
                    <br/>
                    <p><strong>💡 응모율 의미</strong></p>
                    <ul>
                      <li>이벤트 페이지에 진입한 사용자 중 실제 응모한 비율</li>
                      <li>이벤트의 매력도와 참여 유도력을 나타내는 지표</li>
                      <li>높을수록 이벤트 설계가 성공적임을 의미</li>
                    </ul>`
        },
        {
          key: 'complete',
          number: dashboardStats.공유후기남긴사람,
          desc: '공유+주관식 후기<br>남긴 사람',
          percent: calcPercent(dashboardStats.공유후기남긴사람, messageSent),
          width: parseFloat(calcPercent(dashboardStats.공유후기남긴사람, messageSent)),
          colorClass: 'purple',
          change: satisfactionOrReview - dashboardStats.공유후기남긴사람,
          showFor: ['customer'],
          tooltip: `<p><strong>6️⃣ 공유+주관식 후기 남긴 사람</strong></p>
                    <p>카카오톡 공유와 주관식 후기를 모두 작성하여 이벤트를 완전히 완료한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>이전 단계: ${(dashboardStats.응모한사람 || 0).toLocaleString()}명 (응모한사람)</li>
                      <li>현재 단계: ${(dashboardStats.공유후기남긴사람 || 0).toLocaleString()}명 (공유 + 주관식 후기 남긴 사람)</li>
                      <li>완료율: ${calcPercent(dashboardStats.공유후기남긴사람, satisfactionOrReview)}%</li>
                    </ul>
                    <br/>
                    <p><strong>📈 전체 퍼널 요약</strong></p>
                    <ul>
                      <li>시작: ${(messageSent || 0).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                      <li>종료: ${(dashboardStats.공유후기남긴사람 || 0).toLocaleString()}명</li>
                      <li>최종 전환율: ${calcPercent(dashboardStats.공유후기남긴사람, messageSent)}%</li>
                      <li>단계별 최대 이탈: ${Math.max((messageSent || 0) - (kakaoSuccess || 0), (kakaoSuccess || 0) - (pageVisited || 0), (pageVisited || 0) - (dashboardStats.응모한사람 || 0), (dashboardStats.응모한사람 || 0) - (satisfactionOrReview || 0), (satisfactionOrReview || 0) - (completeAll || 0), (completeAll || 0) - (hospitalPageEntered || 0)).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                    </ul>
                    <br/>
                    <p><strong>💡 데이터 의미</strong></p>
                    <ul>
                      <li>이 사용자들이 가장 적극적으로 참여한 핵심 고객입니다</li>
                      <li>1회 이상 공유하고 주관식 후기를 남긴 사람입니다. 가장 가치 있는 피드백을 제공합니다</li>
                      <li>보상 지급의 주요 대상이며, 향후 이벤트 참여 가능성이 높습니다</li>
                    </ul>`
        },
        {
          key: 'hospital',
          number: hospitalPageEntered,
          desc: '병원 목록 페이지<br>진입',
          percent: calcPercent(hospitalPageEntered, isCustomerType?messageSent:total),
          width: parseFloat(calcPercent(hospitalPageEntered, isCustomerType?messageSent:total)),
          colorClass: 'indigo',
          change: dashboardStats.공유후기남긴사람 - hospitalPageEntered,
          showFor: ['customer', 'customer_friend', 'friend_of_friend'],
          tooltip: `<p><strong>7️⃣ 병원 목록 페이지 진입</strong></p>
                    <p>"자이스 스마일 더 알아보기" 버튼을 클릭하여 병원 목록 페이지에 진입한 사용자입니다.</p>
                    <br/>
                    <p><strong>📊 데이터 계산 방식</strong></p>
                    <ul>
                      <li>현재 단계: ${(hospitalPageEntered || 0).toLocaleString()}명 (병원 목록 페이지 진입)</li>
                    </ul>
                    <br/>
                    <p><strong>🎯 마케팅 효과</strong></p>
                    <ul>
                      <li>이벤트 참여 후 실제 병원 정보에 관심을 보인 고객</li>
                      <li>수술 상담이나 예약으로 이어질 가능성이 높음</li>
                      <li>가장 높은 전환 가능성을 가진 고객 그룹</li>
                    </ul>
                    <br/>
                    <p><strong>📈 전체 퍼널 최종 요약</strong></p>
                    <ul>
                      <li>시작: ${(messageSent || 0).toLocaleString()}${selectedView.value === 'messageCount' ? '건' : '명'}</li>
                      <li>최종: ${(hospitalPageEntered || 0).toLocaleString()}명 (병원 목록 페이지 진입)</li>
                      <li>최종 전환율: ${calcPercent(hospitalPageEntered, messageSent)}%</li>
                    </ul>`
        }
      ];
      
      // showFor 속성에 따라 필터링
      return funnelData.filter(item => {
        if (!item.showFor) return true;
        return item.showFor.includes(selectedUserType.value);
      });
    };
    
    // 날짜 필터 옵션
    const dateFilterOptions = [
      { label: '전체', value: 'all' },
      { label: '오늘', value: 'today' },
      { label: '1주일', value: 'week' },
      { label: '1개월', value: 'month' }
    ];
    
    // 병원별 집계 테이블 컬럼
    const hospitalColumns = [
      {
        title: '순위',
        dataIndex: 'rank',
        key: 'rank',
        width: 60,
        align: 'center',
        fixed: 'left'
      },
      {
        title: () => h('span', [
          '병원명',
          h(Tooltip, {
            title: '이벤트에 참여한 병원명입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: 'hospitalName',
        key: 'hospitalName',
        width: 180,
        fixed: 'left'
      },
      {
        title: () => h('span', [
          '응모한사람',
          h(Tooltip, {
            title: '해당 병원에서 이벤트에 응모한 전체 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '응모한사람',
        key: '응모한사람',
        width: 110,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '만족도/후기 응답',
          h(Tooltip, {
            title: '만족도 또는 후기 중 하나라도 응답한 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '만족도/후기작성',
        key: '만족도/후기작성',
        width: 140,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '만족도+후기 모두 응답',
          h(Tooltip, {
            title: '만족도와 후기를 모두 응답하여 이벤트를 완전히 완료한 고객 수입니다.'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: '만족도,후기모두작성',
        key: '만족도,후기모두작성',
        width: 160,
        align: 'right',
        customRender: ({ text }) => text.toLocaleString()
      },
      {
        title: () => h('span', [
          '완전작성률',
          h(Tooltip, {
            title: '전체응답자 중 만족도와 후기를 모두 작성한 비율입니다. (만족도+후기 모두 응답 ÷ 전체응답자 × 100)'
          }, () => h('i', { class: 'fa fa-question-circle', style: 'margin-left: 4px; color: #999; font-size: 12px; cursor: pointer;' }))
        ]),
        dataIndex: 'completionRate',
        key: 'completionRate',
        width: 120,
        align: 'center',
        sorter: (a, b) => a.completionRate - b.completionRate
      }
    ];
    
    // 병원별 집계 테이블 데이터
    const hospitalTableData = computed(() => {
      if (!viewOptions.value || !viewOptions.value[selectedView.value]?.data?.hospitalBreakdown) {
        return [];
      }
      
      const hospitals = viewOptions.value[selectedView.value].data.hospitalBreakdown;
      
      return hospitals.map((hospital, index) => ({
        key: hospital.hospitalId,
        rank: index + 1,
        ...hospital,
        completionRate: hospital['응모한사람'] > 0 
          ? parseFloat(((hospital['만족도,후기모두작성'] / hospital['응모한사람']) * 100).toFixed(1))
          : 0
      }));
    });
    
    // 뒤로가기
    const goBack = () => {
      router.go(-1);
    };

    //기존이벤트들 목록에 추가하는 중
    const selectedEventId = ref('');

    const handleEventChange = (eventId) => {
      console.log(eventId);
      let v3EventIds = ['688c74fa9bad033589258352', '6860e05ccca7ad7006779b45', '6864f97c93111a68978dc3f5'];
      
      if(eventId === 'dummyEventId3') {
        // 후기 이벤트 요약 페이지로 리다이렉트
        router.push('/events-v2/review-summary');
      } else if(!v3EventIds.includes(eventId)) {
        router.push('/events/dashboard');
      }
    };
    
    // 마운트 시 실행
    onMounted(() => {
      // API 인스턴스 초기화 - getCurrentInstance를 사용하여 $apiInstance에 접근
      const { proxy } = getCurrentInstance();
      apiInstance.value = eventsApis(proxy.$apiInstance, store);
            
      // 라우트에서 이벤트 ID를 가져오거나 기본값 사용
      const routeEventId = route.query.eventId;
      eventId.value = routeEventId;
      selectedEventId.value = routeEventId;
      
      if (!eventId.value) {
        message.error('이벤트 ID가 없습니다.');
        router.push('/dashboard');
        return;
      }
      
      // localStorage에서 저장된 사용자 타입 설정 가져오기
      const savedUserType = localStorage.getItem('eventStatsUserType');
      console.log('저장된 사용자 타입:', savedUserType);
      if (savedUserType && (savedUserType === 'customer' || savedUserType === 'customer_friend' || savedUserType === 'friend_of_friend')) {
        selectedUserType.value = savedUserType;
      }
      console.log('현재 selectedUserType 값:', selectedUserType.value);
      
      // localStorage에서 저장된 데이터 뷰 설정 가져오기
      const savedView = localStorage.getItem('eventStatsView');
      console.log('저장된 데이터 뷰 설정:', savedView);
      if (savedView && (savedView === 'uniqueRecipient' || savedView === 'messageCount')) {
        selectedView.value = savedView;
      }
      console.log('현재 selectedView 값:', selectedView.value);
      
      // 이벤트 정보 조회
      loadEventDetails();
      
      // 대시보드 통계 조회
      loadDashboardStatistics();
    });
    
      return {
        eventTitle,
        loading,
        loadingStats,
        dashboardStats,
        dateRange,
        dateFilter,
        dateFilterOptions,
        selectedView,
        selectedUserType,
        viewOptions,
        setDateRange,
        handleDateChange,
        handleViewChange,
        handleUserTypeChange,
        calcPercent,
        getStatCards,
        getVisibleStatCards,
        getFunnelData,
        shouldShowCard,
        goBack,
        hospitalColumns,
        hospitalTableData,
        handleEventChange,
        eventId,
        selectedEventId,
        // EventStatisticsSummary 추가 데이터
        mainEventFunnel,
        friendPatientFunnel,
        participantByTarget,
        participantColumns,
        surgeryParticipants,
        surgeryColumns,
        shareDistribution,
        shareColumns,
        ageDistribution,
        ageColumns,
        messageStats,
        messageColumns,
        rewardStatus,
        rewardStatusColumns,
        rewardDepletion,
        depletionColumns,
        hospitalParticipants,
        hospitalParticipantColumns,
        formatNumber,
        calculateConversion
      };
  }
};
</script>

<style scoped lang="scss">
.titleContainer {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  width: 100%;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}

.date-filter {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #f5f5f5;
  padding: 8px 16px;
  border-radius: 8px;
}

.date-label {
  font-size: 14px;
  color: #666;
  font-weight: 500;
  white-space: nowrap;
}

.date-filter-buttons {
  display: flex;
  gap: 4px;
  
  .ant-btn {
    height: 28px;
    padding: 0 12px;
    font-size: 13px;
    
    &.ant-btn-primary {
      background-color: #1890ff;
      border-color: #1890ff;
    }
  }
}

:deep(.ant-picker-range) {
  height: 32px;
  
  .ant-picker-input > input {
    font-size: 13px;
  }
}

.page-title {
  color: #000;
  font-size: 1.8rem;
  margin: 0;
}

.back-button {
  background-color: #f0f0f0;
  border: 1px solid #d9d9d9;
  color: #595959;
  
  &:hover {
    background-color: #e6e6e6;
    border-color: #d9d9d9;
    color: #595959;
  }
}

.pageDesc {
  font-size: 14px;
  color: #595959;
  margin-top: 8px;
  display: block;
}

.card {
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  border: none;
  overflow: hidden;
}

.content-wrap-card {
  margin-top: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  background-color: #fafafa;
}

.section-title {
  font-size: 16px;
  font-weight: 600;
  color: #000;
  display: flex;
  align-items: center;
}

.content-section {
  padding: 40px 20px;
}

.loading-state {
  text-align: center;
  padding: 60px 20px;
  
  p {
    margin-top: 16px;
    font-size: 14px;
    color: #595959;
  }
}

// 통계 섹션
.stats-section {
  margin-bottom: 40px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

.stats-title {
  font-size: 18px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
  
  i {
    color: #666;
  }
  
  .help-icon,
  .backend-icon {
    font-size: 14px;
    color: #999;
    cursor: pointer;
    margin-left: 4px;
    
    &:hover {
      color: #1890ff;
    }
  }
  
  .backend-icon {
    color: #ff8800;
    
    &:hover {
      color: #ff6600;
    }
  }
  
  .view-switcher {
    margin-left: auto;
    
    :deep(.ant-radio-button-wrapper) {
      height: 28px;
      line-height: 26px;
      padding: 0 12px;
      font-size: 13px;
      
      &.ant-radio-button-wrapper-checked {
        background-color: #1890ff;
        border-color: #1890ff;
        color: white;
        
        &:hover {
          background-color: #40a9ff;
          border-color: #40a9ff;
        }
      }
    }
  }
}

.stats-subtitle {
  font-size: 14px;
  color: #666;
  margin-bottom: 24px;
}

// 전체 현황 요약 카드
.stats-row {
  display: grid;
  gap: 12px;
  margin-bottom: 40px;
  
  // customer (시술받은 환자) - 7개 카드
  &.user-type-customer {
    grid-template-columns: repeat(8, 1fr);
  }
  
  // customer_friend (환자의 친구) - 5개 카드
  &.user-type-customer_friend {
    grid-template-columns: repeat(5, 1fr);
  }
  
  // friend_of_friend (친구의 친구) - 5개 카드
  &.user-type-friend_of_friend {
    grid-template-columns: repeat(5, 1fr);
  }
}

.stat-card {
  border-radius: 12px;
  padding: 24px 16px;
  text-align: center;
  color: white;
  position: relative;
  min-height: 120px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  
  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, rgba(255, 255, 255, 0.15) 0%, rgba(255, 255, 255, 0) 50%, rgba(0, 0, 0, 0.1) 100%);
    pointer-events: none;
  }
  
  &.purple {
    background: linear-gradient(135deg, #8b8ee5 0%, #7c7fdb 100%);
  }
  
  &.pink {
    background: linear-gradient(135deg, #ff8fc3 0%, #ff7eb3 100%);
  }
  
  &.cyan {
    background: linear-gradient(135deg, #00d4e4 0%, #00bcd4 100%);
  }

  &.blue {
    background: linear-gradient(135deg, #1890ff 0%, #1890ff 100%);
  }
  
  &.purple-light {
    background: linear-gradient(135deg, #a8abe5 0%, #9c9fdb 100%);
  }
  &.min-width-185 {
    min-width: 185px;
  }
  
  &.blue-light {
    background: linear-gradient(135deg, #1890ff 0%, #1890ff 100%);
  }
  
  &.pink-light {
    background: linear-gradient(135deg, #ffaed3 0%, #ff9ec3 100%);
  }
  
  &.cyan-light {
    background: linear-gradient(135deg, #00e4f4 0%, #00d4e4 100%);
  }
  
  &.yellow-light {
    background: linear-gradient(135deg, #ffd666 0%, #ffc53d 100%);
  }
  
  &.pink-light {
    background: linear-gradient(135deg, #ffadd2 0%, #ff85c0 100%);
  }
  
  &.green-light {
    background: linear-gradient(135deg, #95de64 0%, #73d13d 100%);
  }
  
  &.purple-light {
    background: linear-gradient(135deg, #b37feb 0%, #9254de 100%);
  }
  
  &.orange {
    background: linear-gradient(135deg, #ff7a45 0%, #ff4d4f 100%);
  }
  
  .stat-icons {
    position: absolute;
    top: 12px;
    right: 12px;
    display: flex;
    gap: 6px;
    z-index: 2;
  }
  
  .stat-help-icon,
  .stat-backend-icon {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    
    &:hover {
      color: rgba(255, 255, 255, 1);
    }
  }
  
  .stat-backend-icon {
    color: rgba(255, 255, 255, 0.6);
  }
}

.stat-number {
  font-size: 32px;
  font-weight: 700;
  margin-bottom: 8px;
  line-height: 1.2;
  position: relative;
  z-index: 1;
}

.stat-desc {
  font-size: 13px;
  margin-bottom: 12px;
  opacity: 0.95;
  line-height: 1.3;
  position: relative;
  z-index: 1;
}

.stat-percent {
  font-size: 16px;
  font-weight: 600;
  opacity: 0.9;
  position: relative;
  z-index: 1;
}

// 퍼널 스타일
.funnel-stats {
  display: flex;
  gap: 16px;
  align-items: flex-start;
  overflow-x: auto;
  padding-bottom: 16px;
}

.funnel-item {
  flex: 1;
  min-width: 150px;
  position: relative;
  
  &.green .funnel-bar {
    background: #52c41a;
  }
  
  &.blue .funnel-bar {
    background: #1890ff;
  }
  
  &.yellow .funnel-bar {
    background: #faad14;
  }
  
  &.orange .funnel-bar {
    background: #fa8c16;
  }
  
  &.red .funnel-bar {
    background: #f5222d;
  }
  
  &.purple .funnel-bar {
    background: #722ed1;
  }
  
  &.indigo .funnel-bar {
    background: #6366f1;
  }
  
  &:last-child .funnel-arrow {
    display: none;
  }
  
  .funnel-help-icon {
    position: absolute;
    top: 15px;
    right: 10px;
    font-size: 14px;
    color: #999;
    cursor: pointer;
    z-index: 10;
    background: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
      color: #1890ff;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }
  }
  
  .funnel-warning-icon {
    position: absolute;
    top: 15px;
    right: 35px;
    font-size: 14px;
    color: #f5222d;
    cursor: pointer;
    z-index: 10;
    background: white;
    border-radius: 50%;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    
    &:hover {
      color: #ff4d4f;
      box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    }
  }
}

.funnel-arrow {
  position: absolute;
  right: -32px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 28px;
  font-weight: 700;
  color: #8c8c8c;
  z-index: 1;
}

.funnel-bar {
  height: 8px;
  border-radius: 4px;
  margin-bottom: 16px;
  margin-top: 35px;
  transition: width 0.3s ease;
  position: relative;
}

.funnel-content {
  text-align: center;
}

.funnel-number {
  font-size: 24px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 8px;
}

.funnel-desc {
  font-size: 13px;
  color: #666;
  margin-bottom: 8px;
  line-height: 1.4;
}

.funnel-percent {
  font-size: 18px;
  font-weight: 600;
  color: #1890ff;
  margin-bottom: 4px;
}

.funnel-change {
  font-size: 12px;
  color: #f5222d;
  font-weight: 500;
}


// 반응형 디자인
@media (max-width: 1200px) {
  .stats-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
  
  .stat-number {
    font-size: 24px;
  }
  
  .funnel-stats {
    flex-direction: column;
    align-items: stretch;
  }
  
  .funnel-item {
    width: 100%;
    margin-bottom: 24px;
  }
  
  .funnel-bar {
    width: 100% !important;
  }
}

// 병원별 집계 테이블 스타일
.hospital-table-wrapper {
  margin-top: 24px;
  background: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.hospital-breakdown-table {
  :deep(.ant-table-thead > tr > th) {
    background: #fafafa;
    font-weight: 600;
    color: #262626;
    border-bottom: 2px solid #f0f0f0;
  }
  
  :deep(.ant-table-tbody > tr > td) {
    padding: 12px 16px;
  }
  
  :deep(.ant-table-tbody > tr:hover > td) {
    background: #f8faff;
  }
}

.hospital-name {
  font-weight: 500;
  color: #262626;
}

.completion-rate {
  display: flex;
  align-items: center;
  gap: 8px;
  
  .rate-value {
    font-weight: 600;
    color: #1890ff;
    min-width: 45px;
    text-align: right;
  }
  
  .rate-bar {
    flex: 1;
    height: 6px;
    background: #f0f0f0;
    border-radius: 3px;
    overflow: hidden;
    position: relative;
    
    .rate-fill {
      height: 100%;
      background: linear-gradient(90deg, #40a9ff 0%, #1890ff 100%);
      transition: width 0.3s ease;
      border-radius: 3px;
    }
  }
}

// 순위별 강조 스타일
:deep(.ant-table-tbody > tr:nth-child(1)) {
  .hospital-name {
    color: #fa8c16;
    font-weight: 600;
  }
}

:deep(.ant-table-tbody > tr:nth-child(2)) {
  .hospital-name {
    color: #1890ff;
    font-weight: 600;
  }
}

:deep(.ant-table-tbody > tr:nth-child(3)) {
  .hospital-name {
    color: #52c41a;
    font-weight: 600;
  }
}

// EventStatisticsSummary 스타일 추가
.statistics-summary-card {
  margin-top: 24px;
  
  .fixed-date-period {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px 16px;
    background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);
    border-radius: 20px;
    border: 1px solid #90caf9;
    
    i {
      color: #1976d2;
      font-size: 14px;
    }
    
    .period-text {
      color: #1976d2;
      font-size: 14px;
      font-weight: 600;
      letter-spacing: 0.5px;
    }
  }
}

.summary-content-section {
  padding: 40px 20px;
}

// 병원 예약 퍼널 분석 스타일 (2열 레이아웃)
.hospital-booking-funnel-section {
  margin-bottom: 40px;
  
  .funnel-main-header {
    text-align: center;
    margin-bottom: 32px;
    padding: 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    color: white;
    
    .section-title {
      color: white;
      margin-bottom: 8px;
      font-size: 24px;
    }
    
    .section-desc {
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
      font-size: 16px;
    }
  }
  
  .funnel-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 100%;
    
    .funnel-header {
      padding: 20px 24px 16px;
      border-bottom: 1px solid #f0f0f0;
      
      &.left-funnel {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        color: white;
      }
      
      &.right-funnel {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
        color: white;
      }
      
      .funnel-title {
        color: inherit;
        margin-bottom: 12px;
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 16px;
        font-weight: 600;
        
        .funnel-info-icon {
          font-size: 14px;
          cursor: help;
          opacity: 0.8;
          transition: opacity 0.3s;
          
          &:hover {
            opacity: 1;
          }
        }
      }
      
      .funnel-summary {
        display: flex;
        gap: 20px;
        font-size: 13px;
        
        .conversion-rate, .total-bookings {
          opacity: 0.9;
          
          strong {
            font-weight: 700;
            font-size: 14px;
          }
        }
      }
    }
  }
  
  .funnel-visualization {
    padding: 24px 20px;
    
    .funnel-step {
      position: relative;
      margin-bottom: 6px;
      
      &:last-child {
        margin-bottom: 0;
      }
      
      .step-bar {
        height: 6px;
        background: #f0f2f5;
        border-radius: 3px;
        overflow: hidden;
        margin-bottom: 10px;
        position: relative;
        
        .step-progress {
          height: 100%;
          background: linear-gradient(90deg, #1890ff, #40a9ff);
          border-radius: 3px;
          transition: all 0.8s ease;
          position: relative;
          
          &::after {
            content: '';
            position: absolute;
            top: 0;
            right: 0;
            width: 15px;
            height: 100%;
            background: linear-gradient(90deg, transparent, rgba(255,255,255,0.3));
            animation: shine 2s infinite;
          }
        }
      }
      
      .step-content {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 16px;
        background: white;
        border-radius: 6px;
        box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
        border-left: 3px solid #1890ff;
        transition: all 0.3s ease;
        
        &:hover {
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          transform: translateY(-1px);
        }
        
        .step-info {
          flex: 1;
          
          .step-title {
            font-size: 14px;
            font-weight: 600;
            color: #1a1a1a;
            margin: 0 0 6px 0;
            line-height: 1.3;
          }
          
          .step-metrics {
            display: flex;
            gap: 12px;
            align-items: center;
            flex-wrap: wrap;
            
            .step-count {
              font-size: 16px;
              font-weight: 700;
              color: #1890ff;
            }
            
            .step-percentage {
              font-size: 12px;
              color: #52c41a;
              font-weight: 600;
              background: #f6ffed;
              padding: 2px 6px;
              border-radius: 10px;
              border: 1px solid #b7eb8f;
            }
            
            .step-conversion {
              font-size: 11px;
              color: #8c8c8c;
              background: #fafafa;
              padding: 1px 5px;
              border-radius: 6px;
            }
          }
        }
        
        .step-arrow {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 24px;
          height: 24px;
          background: #1890ff;
          color: white;
          border-radius: 50%;
          font-size: 10px;
          animation: bounce 2s infinite;
          
          &:hover {
            background: #40a9ff;
          }
        }
      }
      
      // 각 단계별 색상 구분
      &.step-1 .step-content { border-left-color: #1890ff; }
      &.step-1 .step-bar .step-progress { background: linear-gradient(90deg, #1890ff, #40a9ff); }
      
      &.step-2 .step-content { border-left-color: #52c41a; }
      &.step-2 .step-bar .step-progress { background: linear-gradient(90deg, #52c41a, #73d13d); }
      
      &.step-3 .step-content { border-left-color: #faad14; }
      &.step-3 .step-bar .step-progress { background: linear-gradient(90deg, #faad14, #ffc53d); }
      
      &.step-4 .step-content { border-left-color: #13c2c2; }
      &.step-4 .step-bar .step-progress { background: linear-gradient(90deg, #13c2c2, #36cfc9); }
      
      &.step-5 .step-content { border-left-color: #722ed1; }
      &.step-5 .step-bar .step-progress { background: linear-gradient(90deg, #722ed1, #9254de); }
      
      &.step-6 .step-content { border-left-color: #eb2f96; }
      &.step-6 .step-bar .step-progress { background: linear-gradient(90deg, #eb2f96, #f759ab); }
      
      &.step-7 .step-content { border-left-color: #f759ab; }
      &.step-7 .step-bar .step-progress { background: linear-gradient(90deg, #f759ab, #ff85c0); }
    }
  }
}

.funnel-tooltip {
  min-width: 300px;
  p {
    margin-bottom: 8px;
    line-height: 1.5;
    
    &:last-child {
      margin-bottom: 0;
    }
  }
}

// 상세 통계 테이블 섹션 스타일
.detailed-tables-section {
  margin-bottom: 40px;
  
  .section-header {
    text-align: center;
    margin-bottom: 32px;
    padding: 24px;
    background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
    border-radius: 12px;
    color: white;
    
    .section-title {
      color: white;
      margin-bottom: 8px;
      font-size: 24px;
    }
    
    .section-desc {
      color: rgba(255, 255, 255, 0.9);
      margin: 0;
      font-size: 16px;
    }
  }
  
  .table-card {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    height: 100%;
    transition: all 0.3s ease;
    
    &:hover {
      box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
      transform: translateY(-2px);
    }
    
    .card-header {
      padding: 16px 20px;
      border-bottom: 1px solid #f0f0f0;
      
      .card-title {
        color: white;
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        display: flex;
        align-items: center;
        gap: 8px;
        padding: 5px 10px;
        
        i {
          font-size: 16px;
        }
      }
      
      // 각 테이블별 헤더 색상
      &.participant-header {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      }
      
      &.surgery-header {
        background: linear-gradient(135deg, #f093fb 0%, #f5576c 100%);
      }
      
      &.share-header {
        background: linear-gradient(135deg, #4facfe 0%, #00f2fe 100%);
      }
      
      &.age-header {
        background: linear-gradient(135deg, #43e97b 0%, #38f9d7 100%);
      }
      
      &.message-header {
        background: linear-gradient(135deg, #fa709a 0%, #fee140 100%);
      }
      
      &.reward-header {
        background: linear-gradient(135deg, #ff7675 0%, #fd79a8 100%);
      }
      
      &.depletion-header {
        background: linear-gradient(135deg, #a29bfe 0%, #6c5ce7 100%);
      }
    }
    
    .table-content {
      padding: 16px;
      
      :deep(.ant-table) {
        font-size: 12px;
        
        .ant-table-thead > tr > th {
          background: #fafafa;
          border-bottom: 1px solid #f0f0f0;
          padding: 8px 6px;
          font-size: 11px;
          font-weight: 600;
          color: #666;
        }
        
        .ant-table-tbody > tr > td {
          padding: 6px 6px;
          border-bottom: 1px solid #f5f5f5;
          font-size: 11px;
          
          &:first-child {
            font-weight: 500;
            color: #333;
          }
        }
        
        .ant-table-tbody > tr:hover > td {
          background: #f8faff;
        }
      }
    }
  }
}

// 병원별 응모자 수 섹션 스타일
.hospital-participants-section {
  margin-bottom: 40px;
  
  .section-header-simple {
    margin-bottom: 24px;
    padding: 20px 24px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border-radius: 12px;
    text-align: center;
    
    .section-title {
      color: white;
      margin: 0;
      font-size: 20px;
      font-weight: 600;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 10px;
      
      i {
        font-size: 22px;
      }
    }
  }
  
  .hospital-table-content {
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
    
    .hospital-participants-table {
      :deep(.ant-table) {
        .ant-table-thead > tr > th {
          background: #fafafa;
          border-bottom: 2px solid #f0f0f0;
          font-weight: 600;
          color: #333;
          text-align: center;
          
          &.ant-table-cell-fix-left {
            background: #f5f5f5;
            border-right: 1px solid #e8e8e8;
          }
        }
        
        .ant-table-tbody > tr {
          &:nth-child(even) {
            background: #fafafa;
          }
          
          &:hover > td {
            background: #f0f7ff !important;
          }
          
          td {
            border-bottom: 1px solid #f0f0f0;
            
            &.ant-table-cell-fix-left {
              background: inherit;
              border-right: 1px solid #e8e8e8;
              font-weight: 500;
            }
            
            &:not(.ant-table-cell-fix-left) {
              font-family: 'Courier New', monospace;
              font-weight: 500;
            }
          }
        }
      }
    }
  }
}

@keyframes shine {
  0% { transform: translateX(-100%); }
  100% { transform: translateX(100%); }
}

@keyframes bounce {
  0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
  40% { transform: translateY(-3px); }
  60% { transform: translateY(-2px); }
}

// 반응형 디자인
@media screen and (max-width: 768px) {
  // 퍼널 모바일 최적화
  .hospital-booking-funnel-section {
    .funnel-main-header {
      padding: 16px;
      margin-bottom: 20px;
      
      .section-title {
        font-size: 20px;
      }
      
      .section-desc {
        font-size: 14px;
      }
    }
    
    .funnel-card {
      margin-bottom: 20px;
      
      .funnel-header {
        padding: 16px 20px 12px;
        
        .funnel-title {
          font-size: 14px;
        }
        
        .funnel-summary {
          flex-direction: column;
          gap: 6px;
          font-size: 12px;
          
          strong {
            font-size: 13px;
          }
        }
      }
    }
    
    .funnel-visualization {
      padding: 16px;
      
      .funnel-step .step-content {
        padding: 10px 12px;
        
        .step-info .step-title {
          font-size: 12px;
        }
        
        .step-metrics {
          gap: 8px;
          
          .step-count {
            font-size: 14px;
          }
          
          .step-conversion {
            display: none; // 모바일에서는 전환율 숨기기
          }
        }
        
        .step-arrow {
          width: 20px;
          height: 20px;
          font-size: 8px;
        }
      }
    }
  }
}
</style>
<style lang="scss">
.ant-tooltip{
  width: 100%;
  max-width: 350px;
  .ant-tooltip-inner{
    width:100%;
  }
}
</style>